<template>
  <div class="k-page-content adver">
    <el-tabs v-model="activeName" class="box-eltab">
      <el-tab-pane label="广告投放" name="first">
        <div class="top-filter">
          <el-form
            style="margin-bottom: 20px;"
            :inline="true"
            :size="size"
            class="demo-form-inline"
          >
            <!-- <el-form-item>
              <el-select
                filterable
                remote
                reserve-keyword
                :remote-method="remoteMethodAccount"
                placeholder="请输入账户名称或ID"
                clearable
                v-model="searchForm.guestCode"
              >
                <el-option
                  v-for="item in options.account_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>-->
            <el-form-item>
              <el-input v-model="searchForm.taskName" placeholder="请输入任务名称"></el-input>
            </el-form-item>
            <!-- <el-form-item>
					                    <el-select v-model="form.task_status" placeholder="请选择状态">
					                        <el-option label="全部状态" value=""></el-option>
					                        <el-option label="创建失败" value="1"></el-option>
					                        <el-option label="已完成" value="2"></el-option>
					                        <el-option label="正在创建" value="3"></el-option>
					                        <el-option label="部分成功" value="4"></el-option>
					                        <el-option label="等待创建" value="5"></el-option>
					                        <el-option label="任务停止" value="6"></el-option>
					                    </el-select>
            </el-form-item>-->
            <!-- <el-form-item>
					                    <el-select v-model="form.campaign_type" placeholder="请选择计划类型">
					                        <el-option label="全部类型" value=""></el-option>
					                        <el-option label="提升应用安装" value="2"></el-option>
					                        <el-option label="收集销售线索" value="5"></el-option>
					                        <el-option label="提高应用活跃" value="7"></el-option>
					                    </el-select>
            </el-form-item>-->
            <el-form-item>
              <el-date-picker
                align="center"
                :size="size"
                v-model="searchForm.dateTime"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="doSearch">搜索</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="ks_content">
          <div class="ks_toolbar" style="margin-bottom:10px;">
            <p class="title">
              <span>创建记录</span>
              <span style="margin-left:30px">
                <el-link
                  style="font-size: 10px;"
                  type="primary"
                  :underline="false"
                  @click="changeMedia"
                >切换媒体</el-link>
              </span>
            </p>
            <p>
              <el-button type="primary" :size="size" @click="openAllActionDrawer">快手批量</el-button>
            </p>
          </div>
          <el-table
            border
            :data="tableData.list"
            :header-cell-style="{background:'#f5f7fa'}"
            style="width: 100%"
            v-loading="loading"
          >
            <template v-for="(item,index) in publicFields">
              <el-table-column
                v-if="item.value == 'accountId'"
                :label="item.label"
                :width="item.width"
                fixed="left"
              >
                <template slot-scope="scope">
                  {{scope.row.corporationName}}--{{scope.row.accountId}}
                  <template
                    v-if="scope.row.hasMore == 'yes'"
                  >
                    <el-popover
                      placement="right"
                      min-width="250"
                      @show="showMore(scope.row)"
                      trigger="click"
                    >
                      <el-table
                        fit
                        stripe
                        highlight-current-row
                        :data="moreAccount.list"
                        style="width: 100%;"
                      >
                        <el-table-column prop="accountId" label="账户信息" min-width="180">
                          <template
                            slot-scope="scope"
                          >{{scope.row.corporationName}}--{{scope.row.accountId}}</template>
                        </el-table-column>
                      </el-table>

                      <span
                        slot="reference"
                        v-if="scope.row.hasMore == 'yes'"
                        style="color:#007AD6"
                      >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;查看更多</span>
                      <!-- <el-button type="primary" :size="size" >查看更多</el-button> -->
                    </el-popover>
                  </template>
                </template>
              </el-table-column>
              <el-table-column
                v-else-if="item.value == 'speed'"
                :label="item.label"
                :width="item.width"
              >
                <template slot-scope="scope">
                  <span style="font-weight: bold">{{scope.row.successTotal}}/{{scope.row.total}}</span>
                </template>
              </el-table-column>
              <el-table-column
                v-else-if="item.value == 'status'"
                :label="item.label"
                :width="item.width"
              >
                <template slot-scope="scope">
                  <template v-if="scope.row.status == '0'">
                    <el-tag type="info" :size="size" effect="dark">草&nbsp;&nbsp;稿</el-tag>
                  </template>
                  <template v-if="scope.row.status == '1'">
                    <el-tag type="success" :size="size" effect="dark">待投放</el-tag>
                  </template>
                  <template v-if="scope.row.status == '2'">
                    <el-tag type="warning" :size="size" effect="dark">投放中</el-tag>
                  </template>
                  <template v-if="scope.row.status == '3'">
                    <el-tag :size="size" effect="dark">成&nbsp;&nbsp;功</el-tag>
                  </template>
                  <template v-if="scope.row.status == '4'">
                    <el-tag type="danger" :size="size" effect="dark">失败{{scope.row.errorTotal}}条</el-tag>
                  </template>
                </template>
              </el-table-column>
              <el-table-column
                v-else-if="item.value == 'log'"
                :label="item.label"
                :width="item.width"
                fixed="right"
              >
                <template slot-scope="scope">
                  <el-link type="primary" :size="size" @click="createLog(scope.row)">投放详情</el-link>
                </template>
              </el-table-column>
              <el-table-column v-else :label="item.label" :prop="item.value" :width="item.width"></el-table-column>
            </template>
          </el-table>
          <el-pagination
            style="margin-top: 10px;"
            background
            @current-change="handleCurrentChange"
            :current-page="tableData.page | number"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="tableData.rows | number"
            layout="total, prev, pager, next, jumper"
            :total="tableData.total | number"
          ></el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 批量创建 -->
    <el-drawer
      :title="title"
      :visible.sync="drawer"
      size="60%"
      direction="rtl"
      custom-class="k-drawer kPlcreat"
    >
      <el-row type="flex" justify="center">
        <el-col :span="23">
          <el-form
            :size="size"
            ref="addForm"
            :model="addForm"
            :rules="rules.addRules"
            label-width="150px"
          >
            <!-- 选这账户模块 -->
            <el-card class="box-card" :shadow="hover">
              <div slot="header" class="clearfix" :shadow="hover">
                <span>选择账户</span>
              </div>
              <div>
                <el-form-item label="广告投放账户" prop="advertiser_id">
                  <el-select
                    v-model="addForm.advertiser_id"
                    multiple
                    :multiple-limit="1"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="请输入关键词"
                    :remote-method="remoteAccount"
                    @change="accountChange"
                    :loading="loading"
                  >
                    <el-option
                      v-for="item in options.accounts"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <!-- <el-input v-model="inputName" clearable style="width:200px" placeholder="请输入账户名称" @input="remoteAccount">
                                            <el-button slot="append" icon="el-icon-search"></el-button></el-input>
                                            <p>
                                                <el-transfer
                                                style="margin-top:10px;text-align: left; display: inline-block"
                                                v-model="addForm.advertiser_id"
                                                filterable
                                                filter-placeholder="请输入账户名称或ID"
                                                :props="{
                                                    key: 'value',
                                                }"
                                                :titles="['可选', '已选']"
                                                :button-texts="['撤销', '选择']"
                                                :data="options.account_options">
                                                </el-transfer>
                  </p>-->
                </el-form-item>
              </div>
            </el-card>
            <!-- 推广目的模块 -->
            <el-card class="box-card" :shadow="hover">
              <div slot="header" class="clearfix">
                <span>推广目的</span>
              </div>
              <div>
                <el-form-item label="推广目的" prop="campaign.type">
                  <el-radio-group v-model="addForm.campaign.type" @change="accountChange">
                    <el-radio-button label="2">提升应用安装</el-radio-button>
                    <el-radio-button label="5">收集销售线索</el-radio-button>
                    <!-- <el-radio-button label="7">提高应用活跃</el-radio-button> -->
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="投放场景" prop="adgroup.bid_type">
                  <el-radio-group v-model="addForm.adgroup.bid_type">
                    <el-radio-button label="10">常规投放</el-radio-button>
                    <el-radio-button label="12">最大转化</el-radio-button>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="广告计划预算" prop="budget_type">
                  <el-radio-group v-model="addForm.budget_type">
                    <el-radio-button v-if="addForm.adgroup.bid_type == '10'" label="none">不限</el-radio-button>
                    <el-radio-button label="day_budget">统一预算</el-radio-button>
                    <el-radio-button label="day_budget_schedule">分日预算</el-radio-button>
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  label="单日预算金额（元）"
                  prop="campaign.day_budget"
                  v-if="addForm.budget_type == 'day_budget'"
                >
                  <el-input v-model="addForm.campaign.day_budget" placeholder="请输单日预算金额"></el-input>
                </el-form-item>
                <el-form-item
                  label="分日预算金额（元）"
                  prop="campaign.day_budget_schedule"
                  v-if="addForm.budget_type == 'day_budget_schedule'"
                >
                  <el-table :data="dateData" border style="width: 560px">
                    <el-table-column label="周一" align="center" width="80">
                      <template slot-scope="scope">
                        <el-input v-model="addForm.campaign.day_budget_schedule[0]"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="周二" align="center" width="80">
                      <template slot-scope="scope">
                        <el-input v-model="addForm.campaign.day_budget_schedule[1]"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="周三" align="center" width="80">
                      <template slot-scope="scope">
                        <el-input v-model="addForm.campaign.day_budget_schedule[2]"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="周四" align="center" width="80">
                      <template slot-scope="scope">
                        <el-input v-model="addForm.campaign.day_budget_schedule[3]"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="周五" align="center" width="80">
                      <template slot-scope="scope">
                        <el-input v-model="addForm.campaign.day_budget_schedule[4]"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="周六" align="center" width="80">
                      <template slot-scope="scope">
                        <el-input v-model="addForm.campaign.day_budget_schedule[5]"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="周日" align="center" width="80">
                      <template slot-scope="scope">
                        <el-input v-model="addForm.campaign.day_budget_schedule[6]"></el-input>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-form-item>
              </div>
            </el-card>
            <!-- 投放范围模块 -->
            <el-card class="box-card" :shadow="hover">
              <div slot="header" class="clearfix">
                <span>投放范围</span>
              </div>
              <div>
                <el-form-item label="投放范围" prop="adgroup_type">
                  <el-radio-group v-model="addForm.adgroup_type">
                    <el-radio-button label="none">默认</el-radio-button>
                    <el-radio-button label="lianmeng">快手联盟广告</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-card>
            <!-- 用户定向模块 -->
            <el-card class="box-card" :shadow="hover">
              <div slot="header" class="clearfix">
                <span>用户定向</span>
              </div>
              <div>
                <el-form-item label="选择定向包" prop="targets">
                  <el-button type="primary" @click="openTarget">选择定向包</el-button>
                  <span
                    style="margin-left: 20px;color: #999;font-size: 10px;"
                  >已选:&nbsp;&nbsp;{{addForm.targets.length}}</span>
                </el-form-item>
              </div>
            </el-card>
            <!-- 预算排期模块 -->
            <el-card class="box-card" :shadow="hover">
              <div slot="header" class="clearfix">
                <span>预算与排期</span>
              </div>
              <div>
                <el-form-item label="广告组预算" prop="budget_adgroup_type">
                  <el-radio-group v-model="addForm.budget_adgroup_type">
                    <el-radio-button label="none" v-if="addForm.adgroup.bid_type == '10'">不限</el-radio-button>
                    <el-radio-button label="day_budget">统一预算</el-radio-button>
                    <el-radio-button label="day_budget_schedule">分日预算</el-radio-button>
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  label="单日预算金额（元）"
                  prop="adgroup.day_budget"
                  v-if="addForm.budget_adgroup_type == 'day_budget'"
                >
                  <el-input v-model="addForm.adgroup.day_budget" placeholder="请输单日预算金额"></el-input>
                </el-form-item>
                <el-form-item
                  label="分日预算金额（元）"
                  prop="adgroup.day_budget_schedule"
                  v-if="addForm.budget_adgroup_type == 'day_budget_schedule'"
                >
                  <el-table :data="dateData" border style="width: 560px">
                    <el-table-column label="周一" align="center" width="80">
                      <template slot-scope="scope">
                        <el-input v-model="addForm.adgroup.day_budget_schedule[0]"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="周二" align="center" width="80">
                      <template slot-scope="scope">
                        <el-input v-model="addForm.adgroup.day_budget_schedule[1]"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="周三" align="center" width="80">
                      <template slot-scope="scope">
                        <el-input v-model="addForm.adgroup.day_budget_schedule[2]"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="周四" align="center" width="80">
                      <template slot-scope="scope">
                        <el-input v-model="addForm.adgroup.day_budget_schedule[3]"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="周五" align="center" width="80">
                      <template slot-scope="scope">
                        <el-input v-model="addForm.adgroup.day_budget_schedule[4]"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="周六" align="center" width="80">
                      <template slot-scope="scope">
                        <el-input v-model="addForm.adgroup.day_budget_schedule[5]"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="周日" align="center" width="80">
                      <template slot-scope="scope">
                        <el-input v-model="addForm.adgroup.day_budget_schedule[6]"></el-input>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-form-item>
                <el-form-item label="投放方式" prop="speed">
                  <el-radio-group v-model="addForm.adgroup.speed">
                    <el-radio-button label="1">加速投放</el-radio-button>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="排期">
                  <el-radio-group v-model="addForm.actionTimeType">
                    <el-radio-button label="NOW">从今天开始长期投放</el-radio-button>
                    <el-radio-button label="END">设置开始和结束时间</el-radio-button>
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  label="排期时间"
                  v-if="addForm.actionTimeType == 'END'"
                  prop="adgroup.end_time"
                >
                  <el-date-picker
                    :size="size"
                    v-model="addForm.actionTime"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="投放时段">
                  <el-radio-group v-model="addForm.scheduleTimeType">
                    <el-radio-button label="ALL">全天</el-radio-button>
                    <el-radio-button label="ONLY">特定时间</el-radio-button>
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  label="时段"
                  v-if="addForm.scheduleTimeType == 'ONLY'"
                  prop="adgroup.schedule_time"
                >
                  <el-input v-model="addForm.adgroup.schedule_time" readonly style="width:300px">
                    <el-button
                      slot="append"
                      icon="el-icon-thumb"
                      @click="scheduleTimeVisible = true"
                    >选择时段</el-button>
                  </el-input>
                  <Time
                    :visible.sync="scheduleTimeVisible"
                    :time.sync="addForm.adgroup.schedule_time"
                  ></Time>
                </el-form-item>
                <el-form-item label="创意展现形式" prop="adgroup.show_mode">
                  <el-radio-group v-model="addForm.adgroup.show_mode">
                    <el-radio-button label="2">智能优选</el-radio-button>
                    <el-radio-button label="1">随机轮播</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-card>
            <!-- 渠道配置 -->
            <el-card class="box-card" :shadow="hover">
              <div slot="header" class="clearfix">
                <span>渠道配置</span>
              </div>
              <div>
                <el-form-item label="选择渠道包" prop="canals">
                  <el-button type="primary" :size="size" @click="openCanal">选择渠道包</el-button>
                  <span
                    style="margin-left: 20px;color: #999;font-size: 10px;"
                  >已选:&nbsp;&nbsp;{{addForm.canals.length}}</span>
                </el-form-item>
              </div>
            </el-card>
            <!-- 广告投放位置模块 -->
            <el-card class="box-card" :shadow="hover">
              <div slot="header" class="clearfix">
                <span>广告投放位置</span>
              </div>
              <div>
                <el-form-item label="广告位置" prop="adgroup.scene_id">
                  <el-radio-group v-model="addForm.adgroup.scene_id" @change="clearChange">
                    <el-radio-button v-if="addForm.adgroup_type == 'none'" label="1">优选广告位</el-radio-button>
                    <el-radio-button v-if="addForm.adgroup_type == 'none'" label="6">上下滑大屏广告</el-radio-button>
                    <el-radio-button v-if="addForm.adgroup_type == 'none'" label="24">激励视频广告</el-radio-button>
                    <el-radio-button v-if="addForm.adgroup_type == 'lianmeng'" label="5">联盟广告</el-radio-button>
                    <el-radio-button v-if="addForm.adgroup_type == 'lianmeng'" label="10">联盟场景</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-card>
            <!-- 优化目标和计费方式模块 -->
            <el-card class="box-card" :shadow="hover">
              <div slot="header" class="clearfix">
                <span>优化目标和计费方式</span>
              </div>
              <div>
                <el-form-item label="转化目标" prop="adgroup.ocpx_action_type">
                  <el-radio-group
                    v-model="addForm.adgroup.ocpx_action_type"
                    @change="deepConverChange"
                  >
                    <el-radio-button
                      v-for="item in options.ocpx_action_type_options"
                      :key="item.value"
                      :label="item.value"
                    >{{item.label}}</el-radio-button>
                  </el-radio-group>&nbsp;&nbsp;&nbsp;&nbsp;
                  <el-link type="primary" @click="accountChange">重新获取</el-link>
                </el-form-item>
                <el-form-item label="计费方式">
                  <!-- <el-checkbox-group > -->
                  <el-checkbox v-model="checkd">OCPM</el-checkbox>
                  <!-- <el-checkbox label="1" v-if="addForm.adgroup_type == 'lianmeng'">CPM</el-checkbox>
                  <el-checkbox label="2" v-if="addForm.adgroup_type == 'lianmeng'">CPC</el-checkbox>-->
                  <!-- </el-checkbox-group> -->
                </el-form-item>
                <el-form-item prop="adgroup.cpa_bid">
                  <span slot="label">
                    <el-tooltip
                      class="item"
                      content="注意： 例:1.5,为单一出价,作用于每条广告；例:1.5,1.6,1.7,阶梯出价用英文逗号隔开,顺序作用于每条广告中,例:1.5~1.7,区间出价用~有且只有一组，区间内生成随机价格作用于每条广告中"
                      placement="top"
                    >
                      <span>
                        <i class="el-icon-question"></i>转化目标出价
                      </span>
                    </el-tooltip>
                  </span>
                  <el-input
                    v-model="addForm.adgroup.cpa_bid"
                    placeholder="请输入出价，例如：1.5 或者 1.5,1.6,1.7 或者 1.5~1.7"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="深度转化目标"
                  prop="adgroup.deep_conversion_type"
                  v-if="options.deep_conversion_type_options.length > 0"
                >
                  <el-select
                    v-model="addForm.adgroup.deep_conversion_type"
                    clearable
                    placeholder="请选择深度转化目标"
                  >
                    <el-option
                      v-for="item in options.deep_conversion_type_options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  prop="adgroup.deep_conversion_bid"
                  v-if="addForm.adgroup.deep_conversion_type"
                >
                  <span slot="label">
                    <el-tooltip
                      class="item"
                      content="注意： 例:1.5,为单一出价,作用于每条广告；例:1.5,1.6,1.7,阶梯出价用英文逗号隔开,顺序作用于每条广告中,例:1.5~1.7,区间出价用~有且只有一组，区间内生成随机价格作用于每条广告中"
                      placement="top"
                    >
                      <span>
                        <i class="el-icon-question"></i>深度转化出价
                      </span>
                    </el-tooltip>
                  </span>
                  <el-input v-model="addForm.adgroup.deep_conversion_bid" placeholder="请输入深度转化出价 "></el-input>
                </el-form-item>
                <el-form-item
                  label="付费ROI系数"
                  prop="adgroup.roi_ratio"
                  v-if="addForm.adgroup.ocpx_action_type == '191' || addForm.adgroup.ocpx_action_type == '774'"
                >
                  <el-input v-model="addForm.adgroup.roi_ratio" placeholder="请输入ROI系数"></el-input>
                </el-form-item>
              </div>
            </el-card>

            <!-- 创意配置模块 -->
            <el-card class="box-card" :shadow="hover">
              <div slot="header" class="clearfix">
                <span>创意配置</span>
              </div>
              <div>
                <el-form-item label="创意制作方式" prop="adgroup.unit_type">
                  <el-radio-group v-model="addForm.adgroup.unit_type" @change="resetType">
                    <el-radio-button label="4">自定义创意</el-radio-button>
                    <el-radio-button label="7">程序化创意2.0</el-radio-button>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="是否开启智能抽帧" v-if="addForm.adgroup.unit_type == '7'">
                  <el-radio-group v-model="addForm.adgroup.smart_cover">
                    <el-radio-button label="false">关闭</el-radio-button>
                    <el-radio-button label="true">开启</el-radio-button>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="是否开启历史数据挖掘" v-if="addForm.adgroup.unit_type == '7'">
                  <el-radio-group v-model="addForm.adgroup.asset_mining">
                    <el-radio-button label="false">关闭</el-radio-button>
                    <el-radio-button label="true">开启</el-radio-button>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="添加素材" prop="sources">
                  <el-button type="primary" :size="size" @click="openSource">选择素材</el-button>
                  <span
                    style="margin-left: 20px;color: #999;font-size: 10px;"
                  >已选:&nbsp;&nbsp;{{addForm.sources.length}}</span>
                </el-form-item>
                <el-form-item label="设置文案" prop="titles">
                  <el-button type="primary" :size="size" @click="openText">设置文案</el-button>
                  <span
                    style="margin-left: 20px;color: #999;font-size: 10px;"
                  >已选:&nbsp;&nbsp;{{addForm.titles.length}}</span>
                </el-form-item>
                <el-form-item label="高级创意">
                  <el-radio-group v-model="addForm.adgroup.adv_card_option">
                    <el-radio-button label="0">不启用</el-radio-button>
                    <el-radio-button label="1">启用</el-radio-button>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="行动号召按钮" prop="adcreative.action_bar">
                  <el-select
                    v-model="addForm.adcreative.action_bar"
                    clearable
                    filterable
                    placeholder="请选择按钮文案"
                    @focus="typeChange"
                  >
                    <el-option
                      v-for="item in options.action_bar_text_options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="推荐理由">
                  <el-select
                    v-model="addForm.new_expose_tag_value"
                    filterable
                    multiple
                    placeholder="请选择推荐理由"
                    @focus="exposeTagsChange"
                  >
                    <el-option
                      v-for="item in options.new_expose_tag_options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="创意名称" prop="adcreative.package_name">
                  <el-input
                    v-model="addForm.adcreative.package_name"
                    placeholder="请填写创意名称"
                    @blur="handleInputBlur"
                  ></el-input>
                  <el-link
                    :size="size"
                    style="margin-right: 8px;"
                    icon="el-icon-plus"
                    v-for="tag in options.dynamicTags"
                    :key="tag"
                    type="info"
                    @click="addToText(tag,'addForm','adcreative','package_name')"
                  >{{tag}}</el-link>
                </el-form-item>
                <el-form-item label="试玩素材">
                  <el-radio-group v-model="addForm.playable_id_value">
                    <el-radio-button label="0">不启用</el-radio-button>
                    <el-radio-button label="1">启用</el-radio-button>
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  label="试玩相关"
                  v-if="addForm.playable_id_value == '1'"
                  prop="adgroup.playable_id"
                >
                  <el-select
                    v-model="addForm.adgroup.playable_id"
                    filterable
                    clearable
                    placeholder="请选择试玩素材"
                    @focus="playableChange"
                  >
                    <el-option
                      v-for="item in options.new_play_options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label="试玩按钮内容"
                  v-if="addForm.playable_id_value == '1'"
                  prop="adgroup.play_button"
                >
                  <el-radio-group v-model="addForm.adgroup.play_button">
                    <el-radio-button label="1">立即试玩</el-radio-button>
                    <el-radio-button label="2">试玩一下</el-radio-button>
                    <el-radio-button label="3">立即体验</el-radio-button>
                    <el-radio-button label="4">免装试玩</el-radio-button>
                    <el-radio-button label="5">免装体验</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-card>
            <!-- 创意标签模块 -->
            <el-card class="box-card" :shadow="hover">
              <div slot="header" class="clearfix">
                <div style="display: flex;justify-content: space-between;">
                  <span>创建标签</span>
                  <el-button type="primary" @click="openTags" :size="size">设置分类标签</el-button>
                </div>
              </div>
              <div>
                <p>
                  <el-table
                    :header-cell-style="{background:'#eef1f6',color:'#606266'}"
                    :data="addForm.selectTagData"
                    border
                    :size="size"
                    style="width: 100%;"
                  >
                    <el-table-column align="center" prop="tagName" label="标签包名称" width="150"></el-table-column>
                    <el-table-column align="center" prop="categoryName" label="所属分类" width="auto"></el-table-column>
                    <el-table-column align="center" prop="tags" label="标签数" width="80">
                      <template slot-scope="scope">
                        <el-tooltip placement="top">
                          <div slot="content">
                            <el-tag
                              :size="size"
                              v-for="tag in scope.row.tags"
                              :key="tag"
                              type="info"
                              style="margin-right:5px"
                            >{{tag}}</el-tag>
                          </div>
                          <el-link type="primary">{{scope.row.tags.length}}</el-link>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                  </el-table>
                </p>
              </div>
            </el-card>
            <!-- 配置名称 -->
            <el-card class="box-card" :shadow="hover">
              <div slot="header" class="clearfix">
                <span>配置名称</span>
              </div>
              <div>
                <el-form-item label="广告计划名称" prop="campaign.campaign_name">
                  <el-input
                    v-model="addForm.campaign.campaign_name"
                    placeholder="请填写广告计划名称"
                    @blur="handleInputBlur"
                  ></el-input>
                  <p>
                    <el-link
                      :size="size"
                      style="margin-right: 8px;"
                      icon="el-icon-plus"
                      v-for="tag in options.dynamicTags"
                      :key="tag"
                      type="info"
                      @click="addToText(tag,'addForm','campaign','campaign_name')"
                    >{{tag}}</el-link>
                  </p>
                </el-form-item>
                <el-form-item label="广告组名称" prop="adgroup.unit_name">
                  <el-input
                    v-model="addForm.adgroup.unit_name"
                    placeholder="请填写广告组名称"
                    @blur="handleInputBlur"
                  ></el-input>
                  <p>
                    <el-link
                      :size="size"
                      style="margin-right: 8px;"
                      icon="el-icon-plus"
                      v-for="tag in options.dynamicTags"
                      :key="tag"
                      type="info"
                      @click="addToText(tag,'addForm','adgroup','unit_name')"
                    >{{tag}}</el-link>
                  </p>
                </el-form-item>
              </div>
            </el-card>

            <!-- 创建方式 -->
            <el-card class="box-card" :shadow="hover">
              <div slot="header" class="clearfix">
                <span>创建方式</span>
              </div>
              <div>
                <el-form-item label="广告计划" prop="rule.campaign_create_type">
                  <el-radio-group
                    v-model="addForm.rule.campaign_create_type"
                    @change="addForm.rule.adgroup_create_type = ''"
                  >
                    <!-- <el-radio-button label="PLACE">按渠道</el-radio-button> -->
                    <!-- <el-radio-button label="SOURCE" :disabled="addForm.adgroup.unit_type == '7'">按素材</el-radio-button> -->
                    <!-- <el-radio-button label="CAMPAIGN">已有广告计划</el-radio-button> -->
                    <el-radio-button label="CUSTOM">自定义</el-radio-button>
                  </el-radio-group>&nbsp;&nbsp;
                  <el-link type="primary" @click="resetType">重置</el-link>
                </el-form-item>
                <el-form-item label="创建计划数" v-if="addForm.rule.campaign_create_type == 'CUSTOM'">
                  <el-input-number v-model="addForm.rule.campaignNum" :min="1" :max="10"></el-input-number>
                </el-form-item>
                <el-form-item
                  label="广告组"
                  prop="rule.adgroup_create_type"
                  v-if="addForm.rule.campaign_create_type"
                >
                  <el-radio-group
                    v-model="addForm.rule.adgroup_create_type"
                    v-if="addForm.adgroup.unit_type == '4'"
                  >
                    <!-- <el-radio-button label="SOURCE" :disabled="addForm.rule.campaign_create_type == 'PLACE' ? false : true">按素材</el-radio-button> -->
                    <el-radio-button label="ADCREATIVE">按创意</el-radio-button>
                    <!-- <el-radio-button label="TITLE" :disabled="addForm.rule.campaign_create_type == 'SOURCE' ? false : true">按文案</el-radio-button>  -->
                    <!-- <el-radio-button label="TARGET" :disabled="addForm.rule.campaign_create_type == 'SOURCE' ? false : true">按定向</el-radio-button> -->
                    <!-- <el-radio-button label="CUSTOM">自定义</el-radio-button> -->
                  </el-radio-group>
                  <el-radio-group
                    v-model="addForm.rule.adgroup_create_type"
                    v-if="addForm.adgroup.unit_type == '7'"
                  >
                    <!-- <el-radio-button label="SOURCE" :disabled="addForm.rule.campaign_create_type == 'PLACE' ? false : true">按素材</el-radio-button> -->
                    <!-- <el-radio-button label="BID" disabled>按出价</el-radio-button>
                    <el-radio-button label="TARGET" disabled>按定向</el-radio-button>-->
                    <el-radio-button
                      label="CUSTOM"
                      :disabled="addForm.rule.campaign_create_type == 'CUSTOM' ? false : true"
                    >自定义</el-radio-button>
                  </el-radio-group>
                </el-form-item>
                <!-- 自定义创意 -->
                <template v-if="addForm.adgroup.unit_type == '4'">
                  <!-- 按自定义 + 按创意 -->
                  <template
                    v-if="addForm.rule.campaign_create_type == 'CUSTOM' && addForm.rule.adgroup_create_type == 'ADCREATIVE'"
                  >
                    <el-form-item label="单广告组创意数">
                      <el-input-number
                        v-model="addForm.rule.adgroupAdcreativeNum"
                        :min="1"
                        :max="10"
                      ></el-input-number>
                    </el-form-item>
                    <el-form-item label="文案使用规则">
                      <el-radio-group v-model="addForm.rule.title_type">
                        <el-radio-button label="ORDER">顺序</el-radio-button>
                        <el-radio-button label="RAND">随机</el-radio-button>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item
                      class="adgroup_create_type"
                      label="广告组配置"
                      v-if="addForm.rule.adgroup_create_type == 'ADCREATIVE'"
                    >
                      <p style="color:#6b7582">多选下列选项可根据素材数量x【下列选项】组合生成广告组</p>
                      <el-checkbox-group v-model="addForm.rule.adgroupType" style="margin-top:20px">
                        <el-checkbox label="CAMPAIGN" border>广告计划</el-checkbox>
                        <el-checkbox label="TITLE" border>文案</el-checkbox>
                        <el-checkbox label="TARGET" border>定向包</el-checkbox>
                      </el-checkbox-group>
                    </el-form-item>
                  </template>
                </template>
                <!-- 程序化创意 -->
                <template v-if="addForm.adgroup.unit_type == '7'">
                  <!-- 按自定义 + 按自定义 -->
                  <template
                    v-if="addForm.rule.campaign_create_type == 'CUSTOM' && addForm.rule.adgroup_create_type == 'CUSTOM'"
                  >
                    <el-form-item label="单组素材数">
                      <el-input-number v-model="addForm.rule.adgroupSourceNum" :min="1" :max="10"></el-input-number>
                    </el-form-item>
                    <el-form-item label="单计划组数">
                      <el-input-number v-model="addForm.rule.campaignAdgroupNum" :min="1" :max="30"></el-input-number>
                    </el-form-item>
                    <el-form-item label="单广告组作品语数">
                      <el-input-number v-model="addForm.rule.adgroupTitleNum" :min="1" :max="3"></el-input-number>
                    </el-form-item>
                    <el-form-item label="文案使用规则">
                      <el-radio-group v-model="addForm.rule.title_type">
                        <el-radio-button label="ORDER">顺序</el-radio-button>
                        <el-radio-button label="RAND">随机</el-radio-button>
                      </el-radio-group>
                    </el-form-item>
                  </template>
                </template>

                <!-- <el-form-item label="单广告组创意数">
                                        <el-input-number v-model="addForm.rule.adgroupAdcreativeNum" :min="1" :max="10"></el-input-number>
                                    </el-form-item>
                                    <el-form-item label="单计划素材数" prop="rule.campaignSourceNum" v-if="addForm.rule.adgroup_create_type == 'TARGET' && addForm.rule.campaign_create_type == 'SOURCE'">
                                        <el-input-number v-model="addForm.rule.campaignSourceNum" :min="1" :max="10"></el-input-number>
                </el-form-item>-->

                <!-- <el-form-item label="单素材使用封面数" prop="rule.coverSourceNum" v-if="addForm.rule.adgroup_create_type == 'TITLE' || addForm.rule.adgroup_create_type == 'TARGET'">
                                        <el-input-number v-model="addForm.rule.coverSourceNum" :min="1" :max="10"></el-input-number>
                                        <p><i style="color: #007AD6;" class="el-icon-warning-outline"></i><span style="color:#6b7582">如果设置数值大于选择的封面数量，系统以素材数为准进行创建</span></p>
                </el-form-item>-->
              </div>
            </el-card>
            <!-- 创建时间 -->
            <el-card class="box-card" :shadow="hover">
              <div slot="header" class="clearfix">
                <span>创建时间</span>
              </div>
              <div>
                <el-form-item label="创建时间" prop="time_type">
                  <el-radio-group v-model="addForm.time_type">
                    <el-radio-button label="NOW">立即创建</el-radio-button>
                    <!-- <el-radio-button label="HOUR">半小时后</el-radio-button>
                                            <el-radio-button label="ONE">1小时候</el-radio-button>
                    <el-radio-button label="CUSTOM">自定义</el-radio-button>-->
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="创建完成广告状态">
                  <el-tooltip
                    :content="addForm.adgroup.put_status == '2' ? '暂停' : '投放'"
                    placement="top"
                  >
                    <el-switch
                      v-model="addForm.adgroup.put_status"
                      active-color="#13ce66"
                      inactive-color="#d7dae1"
                      active-value="0"
                      inactive-value="2"
                    ></el-switch>
                  </el-tooltip>
                </el-form-item>
                <el-form-item label="任务名称" prop="task_name">
                  <el-input v-model="addForm.task_name" placeholder="请填写任务名称"></el-input>
                </el-form-item>
                <!-- <el-form-item label="存为模板">
                                        <el-checkbox v-model="addForm.isTemplate">存为模板</el-checkbox>
                                    </el-form-item>
                                    <el-form-item label="模板名称" prop="templateName" v-if="addForm.isTemplate">
                                        <el-input v-model="addForm.templateName" placeholder="请输入模板名称"></el-input>
                </el-form-item>-->
              </div>
            </el-card>
          </el-form>
        </el-col>
      </el-row>
      <el-row type="flex" justify="end">
        <el-col :span="8">
          <div class="demo-drawer__footer">
            <el-button @click="drawer = false" :size="size">取 消</el-button>
            <el-button
              type="primary"
              @click="submitTemplate('addForm')"
              :size="size"
              v-if="addForm.isTemplate"
            >保存模板</el-button>
            <el-button
              type="primary"
              :size="size"
              @click="submitInfo('addForm','ADD')"
            >{{ loading ? '提交中 ...' : '确 定' }}</el-button>
            <el-button type="primary" :size="size" @click="submitInfo('addForm','VIEW')">预览</el-button>
          </div>
        </el-col>
      </el-row>
      <div style="height: 50px;"></div>
      <!-- 生成预览 -->
      <el-drawer
        title="预览"
        :append-to-body="true"
        size="80%"
        custom-class="previewDialog"
        :visible.sync="innerDrawer"
      >
        <div class="previewTitle">
          <span>计划数:{{viewInfo.campaign_num}}</span>
          <span>广告组:{{viewInfo.group_num}}</span>
          <span>创意数:{{viewInfo.total_num}}</span>
        </div>
        <el-table :data="viewData" border style="width: 100%" row-key="lid">
          <el-table-column property="idTxt" label="结构" width="150"></el-table-column>
          <el-table-column property="campaign_name" label="计划名称" width="150"></el-table-column>
          <el-table-column property="unit_name" label="广告组名称" width="200"></el-table-column>
          <el-table-column label="创意名称">
            <template slot-scope="scope">
              <span v-if="scope.row.package_name">{{scope.row.package_name}}</span>
              <span v-if="scope.row.creative_name">{{scope.row.creative_name}}</span>
            </template>
          </el-table-column>
          <el-table-column property="template_name" label="定向包名"></el-table-column>
          <el-table-column label="素材">
            <template slot-scope="scope">
              <div class="sourceCover" v-if="scope.row.oldCover">
                <img :src="scope.row.oldCover" />
              </div>
              <div class="sourceCover" v-if="scope.row.photo_list">
                <img :src="scope['row']['photo_list'][0]['oldCover']" />
                <span>+{{scope.row.photo_list.length}}</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-drawer>
    </el-drawer>
    <!-- 素材弹窗 -->
    <el-dialog
      title="素材选择"
      :visible.sync="dialogSourceVisible"
      custom-class="target-dialog"
      width="95%"
      top="30px"
      @opened="loading = false"
    >
      <el-tabs v-model="sourceData.activeName">
        <el-tab-pane label="素材库" name="all" v-loading="loading">
          <div class="sourceBox">
            <div class="sourceBoxTop">
              <el-select
                v-if="lineDisabled"
                clearable
                :size="size"
                v-model="sourceForm.sourceStatus"
                placeholder="请选择"
              >
                <!-- <el-option label="视频库删除" value="0"></el-option> -->
                <el-option label="可用状态" value="1"></el-option>
                <el-option label="转码中" value="2"></el-option>
                <el-option label="审核中" value="3"></el-option>
                <el-option label="转码失败" value="11"></el-option>
                <el-option label="审核失败" value="12"></el-option>
                <el-option label="已屏蔽" value="13"></el-option>
                <el-option label="视频在客户端删除" value="14"></el-option>
              </el-select>
              <el-date-picker
                align="center"
                clearable
                :size="size"
                value-format="yyyy-MM-dd"
                v-model="sourceForm.sourceTime"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
              <el-input
                v-if="lineDisabled"
                clearable
                placeholder="视频标签"
                v-model="sourceForm.sourceTag"
                :size="size"
                style="width: 200px;"
              ></el-input>
              <el-input
                clearable
                placeholder="视频ID或名称"
                v-model="sourceForm.sourceNameInput"
                :size="size"
                style="width: 200px;"
              >
                <el-button slot="append" @click="getSourceInfo('','')">查询</el-button>
              </el-input>
            </div>
            <div class="sourceBoxCen">
              <div class="sourceBoxCenLeft">
                <div class="sourceHeader">
                  <div>请选择账户</div>
                </div>
                <div class="target-box-left">
                  <ul>
                    <li
                      :title="item.label"
                      v-for="(item,index) in addForm.selectAdvertisersToNew"
                      :key="item.value"
                      :class="item.class"
                      @click="clickTarget(item.value,index,'source')"
                    >{{item.label}}</li>
                  </ul>
                </div>
                <!-- <div class="sourceCenter">
                                <div class="sourceTree">
                                    <el-input
                                    placeholder="搜索文件夹"
                                    v-model="input"
                                    :size="size"
                                    clearable>
                                    </el-input> 
                                </div>
                </div>-->
              </div>
              <div class="sourceBoxCenCon">
                <div class="sourceHeader">
                  <div>素材列表</div>
                  <div style="display: flex;">
                    <el-link
                      type="primary"
                      icon="el-icon-check"
                      :size="size"
                      @click="allSelect"
                      v-if="allDisabled"
                    >全选</el-link>
                    <el-link
                      type="primary"
                      icon="el-icon-close"
                      :size="size"
                      @click="allCanal"
                      v-if="!allDisabled"
                    >取消</el-link>&nbsp; &nbsp;
                    <el-link
                      :disabled="sourceDisabled"
                      icon="el-icon-upload"
                      type="primary"
                      :size="size"
                      @click="getLineInfo"
                    >同步素材</el-link>&nbsp; &nbsp;
                    <el-dropdown @command="handleCommand" trigger="click">
                      <span class="el-dropdown-link">
                        <span
                          style="font-size:10px"
                        >素材来源：{{sourceForm.sourceFrom == 'LINE' ? '在线' : '本地'}}</span>
                        <i class="el-icon-arrow-down el-icon--right"></i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="LINE">在线</el-dropdown-item>
                        <el-dropdown-item command="LOCAL">本地</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div>
                <div class="sourceCenter">
                  <div class="sourceOption">
                    <div
                      class="material-component"
                      v-for="item in sourceTableData.data"
                      :key="item.id"
                      @click="addSourceItem(item)"
                    >
                      <div class="block-mid-lis">
                        <div class="mid-lis-img">
                          <div class="imgBox-Box not-dragging">
                            <img :src="item.coverUrl" class="imgBox-img" />
                          </div>
                          <div
                            class="adesk__material-use-status status-0"
                            v-if="item.isStatus == 3"
                          >未推送</div>
                          <div
                            class="adesk__material-use-status status-2"
                            v-if="item.isStatus == 2"
                          >已推送</div>
                          <div
                            class="adesk__material-use-status status-4"
                            v-if="item.isStatus == 1"
                          >有消耗</div>
                          <div class="adesk__material-show">
                            <i class="el-icon-zoom-in" @click.stop="showView(item)"></i>
                          </div>
                        </div>
                        <div class="mask-cover" v-if="item.isType">
                          <i class="el-icon-check"></i>
                        </div>
                        <!-- <el-tooltip :content="item.name" placement="bottom" effect="light"> -->
                        <el-popover placement="top-start" title="信息" width="400" trigger="hover">
                          <p>素材ID:&nbsp;{{item.videoId}}</p>
                          <p>名称:&nbsp;{{item.name}}</p>
                          <p>尺寸:&nbsp;{{item.rate == '1' ? '竖版视频' : '横版视频'}}</p>
                          <p>标签:&nbsp;{{returnTxt(item.photo_tag)}}</p>
                          <div class="mid-lis-title" slot="reference">{{item.name}}</div>
                        </el-popover>
                        <!-- </el-tooltip> -->
                      </div>
                    </div>
                  </div>
                  <div class="sourceOptionPage">
                    <el-pagination
                      background
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChangeSource"
                      :current-page="sourceTableData.page | number"
                      :page-sizes="[30, 50, 100]"
                      :page-size="sourceTableData.rows | number"
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="sourceTableData.total | number"
                    ></el-pagination>
                  </div>
                </div>
              </div>
              <div class="sourceBoxCenRight">
                <div class="sourceHeader">
                  <div>已选素材</div>
                  <div style="color: #007AD6; cursor: pointer;">
                    <span
                      v-if="(addForm.adgroup.unit_type == '4' || (addForm.adgroup.unit_type == '7' && addForm.adgroup.smart_cover == 'false')) && addForm.selectSourceData.length > 0"
                      style="margin-right:5px;"
                      @click="openCover('')"
                    >批量封面</span>
                    <span @click="cleaSource">清空已选</span>
                  </div>
                </div>
                <div class="sourceCenter">
                  <div class="sourceSelect">
                    <div
                      class="material-info"
                      v-for="item in addForm.selectSourceData"
                      :key="item.info.id"
                    >
                      <div class="material-info-base">
                        <div class="image">
                          <img :src="item.info.coverUrl" />
                        </div>
                        <div class="material-name double-ellipsis">
                          <p class="mid-lis-title">
                            <i
                              class="creative-templeate-tag t1"
                            >{{item.info.rate == '2' ? '横版视频' : '竖版视频'}}</i>
                            {{item.info.name}}
                          </p>
                          <p
                            v-if="addForm.adgroup.unit_type == '4' || (addForm.adgroup.unit_type == '7' && addForm.adgroup.smart_cover == 'false')"
                            class="mid-lis-title"
                          >
                            <el-link
                              type="primary"
                              @click="openCover(item)"
                            >封面设置(+{{returnNumber(item.info.id)}})</el-link>
                          </p>
                        </div>
                      </div>
                      <div class="material-delete" @click="delSource(item)">
                        <i class="el-icon-delete"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button :size="size" @click="dialogSourceVisible = false">取 消</el-button>
        <el-button :size="size" type="primary" @click="addSources">确 定</el-button>
      </div>
    </el-dialog>
    <!--批量封面-->
    <el-dialog
      title="封面选择"
      :visible.sync="dialogCoverVisible"
      custom-class="target-dialog"
      width="95%"
      top="30px"
      @opened="loading = false"
    >
      <div class="kCover" v-loading="loading">
        <div class="coverTop">
          <div style="display: flex;">
            <div>
              <el-radio-group v-model="coverOption" :size="size">
                <el-radio-button label="手动选择"></el-radio-button>
                <el-radio-button :disabled="coverDisabled" label="自动选择"></el-radio-button>
              </el-radio-group>
            </div>
            <div style="margin-left: 20px;" v-if="coverOption == '自动选择'">
              每个素材至少选择
              <el-input-number v-model="coverNum" :min="1" :max="8" :size="size"></el-input-number>个封面
              <el-button type="primary" :size="size" @click="autoSelect">确定</el-button>
            </div>
          </div>
          <div class="coverTip">切换选择方式会清空当前已选素材</div>
        </div>
        <div class="coverBox">
          <div class="coverBoxTitle">
            <div class="left">已选素材{{addForm.selectCoverData.length}}个</div>
            <div class="right">
              <span>
                <!-- <el-checkbox v-model="coverAll">全选</el-checkbox> -->
              </span>
              <!-- <span>已选封面8个</span> -->
            </div>
          </div>
          <div class="coverBoxCon">
            <div
              class="coverList"
              v-for="(item,index) in addForm.selectCoverData"
              :key="index"
              v-if="item.isShow"
            >
              <div class="left">
                <video
                  :id="'showVideo'+index"
                  :src="item.url"
                  :poster="item.coverUrl"
                  controls="controls"
                  preload="none"
                  controlslist
                  style="width: 200px; height: 320px;"
                ></video>
              </div>
              <div class="right">
                <div v-for="(image,i) in item.coverList" :key="i">
                  <el-checkbox v-model="image.checkStatus"></el-checkbox>
                  <img :src="image.url" alt />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button :size="size" @click="clearCover">取 消</el-button>
        <el-button :size="size" type="primary" @click="addCover">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 渠道弹窗 -->
    <el-dialog
      title="渠道选择"
      :visible.sync="dialogCanalVisible"
      custom-class="target-dialog"
      width="70%"
      top="30px"
    >
      <el-tabs v-model="canalData.activeName">
        <el-tab-pane label="账户渠道包" name="place">
          <!-- 内容 -->
          <div class="target-box">
            <!-- 账户内容 -->
            <div class="target-box-left">
              <ul>
                <li
                  :title="item.label"
                  v-for="(item,index) in addForm.selectAdvertisersToNew"
                  :key="item.value"
                  :class="item.class"
                  @click="clickTarget(item.value,index,'place')"
                >{{item.label}}</li>
              </ul>
            </div>
            <div class="target-box-right">
              <!-- 搜索内容 -->
              <!-- <div class="target-box-right-top">
                        <el-button type="primary" :size="size" @click="locationView">新建渠道包</el-button>
              </div>-->
              <div class="target-box-right-bot">
                <!-- 定向内容 -->
                <div class="target-data">
                  <el-table
                    ref="canalTable"
                    v-loading="loading"
                    :data="canalTableData.data"
                    border
                    :size="size"
                    height="100%"
                    style="width: 100%;"
                    @select-all="(vals)=>{selectAll(vals,'selectCanalData','canalTableData')}"
                    @row-click="(row, column, event)=>handleSelectionChange(row, column, event, 'selectCanalData', 'canalTable')"
                  >
                    <el-table-column align="center" type="selection" width="55"></el-table-column>
                    <el-table-column align="center" prop="label" width="auto" label="渠道包名称"></el-table-column>
                  </el-table>
                  <el-pagination
                    background
                    @current-change="handleCurrentChangeCanal"
                    :current-page="canalTableData.page | number"
                    :page-size="canalTableData.rows | number"
                    layout="total, prev, pager, next, jumper"
                    :total="canalTableData.total | number"
                  ></el-pagination>
                </div>
                <!-- 已选内容 -->
                <div class="target-checked">
                  <h3>
                    <span>已选:{{addForm.selectCanalData.length}}</span>
                    <span @click="cleanTarget('selectCanalData','canalTable')">清空</span>
                  </h3>
                  <div class="target-checked-con">
                    <ul>
                      <li v-for="(item,index) in addForm.selectCanalData" :key="index">
                        {{item.label}}
                        <i
                          class="el-icon-close"
                          @click="delTarget(index,'selectCanalData','canalTable')"
                        ></i>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <!-- <el-tab-pane label="通用定向包" name="nomal"></el-tab-pane> -->
      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button :size="size" @click="dialogCanalVisible = false ">取 消</el-button>
        <el-button :size="size" type="primary" @click="addCanal">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 标题弹窗 -->
    <el-dialog title="标题选择" :visible.sync="dialogTextVisible" width="50%" top="30px">
      <el-form
        ref="textForm"
        label-position="top"
        :model="textForm"
        label-width="80px"
        :rules="rules.textRuls"
        :size="size"
      >
        <el-form-item label="批量标题（请输入或粘贴创意标题，每行一标题，敲击回车换行）" prop="textInfo">
          <el-input
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 10}"
            placeholder="请输入标题内容"
            v-model="textForm.textInfo"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :size="size" @click="dialogTextVisible = false">取 消</el-button>
        <el-button :size="size" type="primary" @click="addTitles">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 定向弹窗 -->
    <el-dialog
      title="定向选择"
      :visible.sync="dialogTargetVisible"
      custom-class="target-dialog"
      width="70%"
      top="30px"
    >
      <el-tabs v-model="targetData.activeName">
        <el-tab-pane label="媒体定向包" name="media">
          <!-- 内容 -->
          <div class="target-box">
            <!-- 账户内容 -->
            <div class="target-box-left">
              <ul>
                <li
                  :title="item.label"
                  v-for="(item,index) in addForm.selectAdvertisersToNew"
                  :key="item.value"
                  :class="item.class"
                  @click="clickTarget(item.value,index,'tar')"
                >{{item.label}}</li>
              </ul>
            </div>
            <div class="target-box-right">
              <!-- 搜索内容 -->
              <!-- <div class="target-box-right-top">
                        <el-button type="primary" :size="size">新建媒体定向包</el-button>
              </div>-->
              <div class="target-box-right-bot">
                <!-- 定向内容 -->
                <div class="target-data">
                  <el-table
                    ref="targetTable"
                    v-loading="loading"
                    :data="targetTableData.data"
                    border
                    :size="size"
                    height="100%"
                    style="width: 100%;"
                    @select-all="(vals)=>{selectAll(vals,'selectData','targetTableData')}"
                    @row-click="(row, column, event)=>handleSelectionChange(row, column, event, 'selectData','targetTable')"
                  >
                    <!-- <el-table-column
                            type="selection"
                            width="55">
                    </el-table-column>-->
                    <el-table-column prop="label" width="auto" label="定向模板名称"></el-table-column>
                  </el-table>
                  <el-pagination
                    background
                    @current-change="handleCurrentChangeTarget"
                    :current-page="targetTableData.page | number"
                    :page-size="targetTableData.rows | number"
                    layout="total, prev, pager, next, jumper"
                    :total="targetTableData.total | number"
                  ></el-pagination>
                </div>
                <!-- 已选内容 -->
                <div class="target-checked">
                  <h3>
                    <span>已选:{{addForm.selectData.length}}</span>
                    <span @click="cleanTarget('selectData','targetTable')">清空</span>
                  </h3>
                  <div class="target-checked-con">
                    <ul>
                      <li v-for="(item,index) in addForm.selectData" :key="index">
                        {{item.label}}
                        <i
                          class="el-icon-close"
                          @click="delTarget(index,'selectData','targetTable')"
                        ></i>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <!-- <el-tab-pane label="通用定向包" name="nomal"></el-tab-pane> -->
      </el-tabs>

      <!-- <el-select v-model="addForm.target_ids" filterable placeholder="请选择定向模板" clearable >
            <el-option
              v-for="item in targets_options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
      </el-select>-->
      <div slot="footer" class="dialog-footer">
        <el-button :size="size" @click="dialogTargetVisible = false">取 消</el-button>
        <el-button :size="size" type="primary" @click="addTargets">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 标签包弹窗 -->
    <el-dialog
      title="标签包选择"
      :visible.sync="dialogTagVisible"
      custom-class="target-dialog"
      width="70%"
      top="30px"
    >
      <el-tabs v-model="tagData.activeName" @tab-click="exitEditId">
        <el-tab-pane label="选择标签包" name="tag">
          <!-- 内容 -->
          <div class="target-box">
            <div class="target-box-right" style="width: 100%;margin-left: 0;">
              <div class="target-box-right-bot" style="margin-top: 0;height: 100%;">
                <!-- 定向内容 -->
                <div class="target-data">
                  <el-table
                    :header-cell-style="{background:'#eef1f6',color:'#606266'}"
                    ref="tagTable"
                    v-loading="loading"
                    :data="tagTableData.data"
                    border
                    :size="size"
                    height="100%"
                    style="width: 100%;"
                    @select-all="(vals)=>{selectAll(vals,'selectTagData','tagTableData')}"
                    @row-click="(row, column, event)=>handleSelectionChange(row, column, event, 'selectTagData','tagTable')"
                  >
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column prop="tagName" label="标签包名称" width="200"></el-table-column>
                    <el-table-column prop="categoryName" label="所属分类" width="220"></el-table-column>
                    <el-table-column label="标签" width="200">
                      <template slot-scope="scope">
                        <el-tooltip placement="top">
                          <div slot="content">
                            <el-tag
                              :size="size"
                              v-for="tag in scope.row.tags"
                              :key="tag"
                              type="info"
                              style="margin-right:5px"
                            >{{tag}}</el-tag>
                          </div>
                          <el-link type="primary">{{scope.row.tags.length}}</el-link>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" label="操作" width="180">
                      <template slot-scope="scope">
                        <el-link type="primary" @click.stop="editTag(scope.row.id)">修改</el-link>
                        <el-link type="primary" @click.stop="delTag(scope.row.id)">删除</el-link>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-pagination
                    background
                    @current-change="handleCurrentChangeTag"
                    :current-page="tagTableData.page | number"
                    :page-size="tagTableData.rows | number"
                    layout="total, prev, pager, next, jumper"
                    :total="tagTableData.total | number"
                  ></el-pagination>
                </div>
                <!-- 已选内容 -->
                <div class="target-checked">
                  <h3>
                    <span>已选:{{addForm.selectTagData.length}}</span>
                    <span @click="cleanTarget('selectTagData','tagTable')">清空</span>
                  </h3>
                  <div class="target-checked-con">
                    <ul>
                      <li v-for="(item,index) in addForm.selectTagData" :key="index">
                        {{item.tagName}}
                        <i
                          class="el-icon-close"
                          @click="delTarget(index,'selectTagData','tagTable')"
                        ></i>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="自定义添加" name="custom">
          <el-form
            :model="tagForm"
            :rules="rules.tagRuls"
            :size="size"
            ref="tagForm"
            label-width="100px"
          >
            <el-form-item label="标签包名称" prop="tagName" style="width:25%">
              <el-input v-model="tagForm.tagName"></el-input>
            </el-form-item>
            <el-form-item label="创意分类" prop="categoryId">
              <!-- <el-form-item :label="tagForm.categoryId" prop="categoryId"> -->
              <el-cascader
                v-model="tagForm.categoryId"
                :options="options.category_options"
                :props="{ expandTrigger: 'hover' }"
              ></el-cascader>
            </el-form-item>
            <el-form-item label="创意标签" prop="tags" style="width:50%">
              <el-input
                placeholder="每个标签不超过10字，可空格分割"
                v-model="tagForm.tagsText"
                class="input-with-select"
              >
                <el-button slot="append" @click="addTagText">添加</el-button>
              </el-input>
              <el-tag
                :size="size"
                v-for="tag in tagForm.tags"
                :key="tag"
                type="info"
                closable
                style="margin-right:5px"
                @close="tagClose(tag)"
              >{{tag}}</el-tag>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitTagForm('tagForm')">立即创建</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer">
        <el-button :size="size" @click="dialogTagVisible = false">取 消</el-button>
        <el-button :size="size" type="primary" @click="addTags">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 日志 -->
    <el-dialog title="日志详情" :visible.sync="dialogVisibleLabel" width="80%">
      <el-table
        :data="tableDataDrawer.list"
        style="width: 100%;"
        center
        border
        fit
        stripe
        max-height="400"
        :cell-style="{padding: '0'}"
        highlight-current-row
      >
        <el-table-column property="id" fixed label="序号" width="80"></el-table-column>
        <el-table-column property="advertiser_name" min-width="250" label="账户"></el-table-column>
        <el-table-column property="name" min-width="250" label="名称"></el-table-column>
        <el-table-column label="操作对象" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.type == 'GROUP'">广告组</span>
            <span v-if="scope.row.type == 'CAMPAIGN'">广告计划</span>
            <span v-if="scope.row.type == 'CREATIVE'">广告创意</span>
          </template>
        </el-table-column>
        <el-table-column property="create_time" min-width="180" label="操作时间"></el-table-column>
        <el-table-column property="code" width="80" label="状态码"></el-table-column>
        <el-table-column property="message" min-width="200" label="备注">
          <template slot-scope="scope">
            <span v-if="scope.row.code != 0" style="color: red">{{scope.row.message}}</span>
            <span v-else style="color: green">成功</span>
          </template>
        </el-table-column>
      </el-table>
      <el-row>
        <el-col :span="24">
          <el-pagination
            background
            @current-change="handleCurrentChangeDrawer"
            :current-page="tableDataDrawer.page | number"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="tableDataDrawer.rows | number"
            layout="total, prev, pager, next, jumper"
            :total="tableDataDrawer.total | number"
          ></el-pagination>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :size="size" @click="dialogVisibleLabel = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 预览 -->
    <el-dialog :visible.sync="showDialogVisible" @close="stopVideo('showVideo')">
      <div style="display: flex;justify-content: center;">
        <video
          id="showVideo"
          :src="dialogImageUrl.url"
          :poster="dialogImageUrl.coverUrl"
          controls="controls"
          preload="none"
          controlslist
          style="width: 360px; height: 100%;"
        >
          <a class="btn_play"></a>
        </video>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// 引入公共组件供页面使用
import Time from '@/components/Time.vue'
export default {
  props: ['info'],
  components: {
    Time
  },
  data() {
    return {
      activeName: 'first',
      lineDisabled: true,
      sourceDisabled: false,
      allDisabled: true,
      timer: '',
      coverDisabled: false,
      showDialogVisible: false,
      dialogImageUrl: '',
      innerDrawer: false,
      dialogTagVisible: false,
      dialogCanalVisible: false,
      selectionStart: '',
      scheduleTimeVisible: false,
      dialogTextVisible: false,
      dialogSourceVisible: false,
      dialogCoverVisible: false,
      dialogTargetVisible: false,
      coverOption: '手动选择',
      coverNum: '1',
      coverAll: false,
      coverDatas: [],
      publicFields: [
        {
          value: 'id',
          label: '任务ID',
          width: '80px'
        },
        {
          value: 'name',
          label: '任务名称',
          width: '250px'
        },
        {
          value: 'advertiser_name',
          label: '账户信息',
          width: '300px'
        },
        {
          value: 'nickname',
          label: '创建人',
          width: '100px'
        },
        {
          value: 'create_time',
          label: '创建时间',
          width: '180px'
        },
        {
          value: 'speed',
          label: '进度',
          width: '100px'
        },
        {
          value: 'status',
          label: '状态',
          width: '120px'
        },
        {
          value: 'log',
          label: '投放详情',
          width: 'auto'
        }
      ],
      drawer: false,
      title: '批量创建',
      inputName: '',
      loading: false,
      size: 'mini',
      pageTitle: '快手批量',
      hover: 'hover',
      sourceForm: {
        sourceFrom: 'LINE',
        sourceTime: '',
        sourceTag: '',
        sourceStatus: '1',
        sourceNameInput: ''
      },
      input: '',
      checkd: true,
      getUrl: {
        account_url: 'release/getUserAccountIdList',
        target_url: 'release/getTemplateList',
        btnText_url: 'release/getActionBarTextList',
        exposeTags_url: 'release/getExposeTagsList',
        play_url: 'release/getPlayableList',
        canal_url: 'release/getPlaceSelect',
        category_url: 'release/getCreativeCategoryList',
        addTag_url: 'release/addTagPackageInfo',
        tagList_url: 'release/getTagPackage',
        delTag_url: 'release/delTagPackage',
        getTag_url: 'release/getPackageInfo',
        source_url: 'release/getSourceList',
        ocpx_url: 'release/getOcpxTypes',
        deep_url: 'release/getConversionInfos',
        submit_url: 'release/view',
        source_del: 'release/delCoverList',
        sourceLine_url: 'release/synchronousData'
      },
      searchForm: {
        dimension: 'ks',
        type: 'TASK',
        taskName: '',
        // guestCode: '',
        dateTime: []
      },
      targetData: {
        activeName: 'media'
      },
      sourceData: {
        activeName: 'all'
      },
      canalData: {
        activeName: 'place'
      },
      tagData: {
        activeName: 'tag'
      },
      dateData: [{}],
      tagForm: {
        id: '',
        tagName: '',
        categoryId: [],
        categoryName: [],
        tagsText: '',
        tags: []
      },
      addForm: {
        advertiser_id: [],
        budget_type: 'none',
        budget_adgroup_type: 'none',
        adgroup_type: 'none',
        target_ids: [],
        new_expose_tag_value: [],
        playable_id_value: '0',
        task_name: '',
        isTemplate: false,
        rule: {
          campaign_create_type: '',
          campaignNum: 1,
          adgroup_create_type: '',
          title_type: 'ORDER',
          adgroupSourceNum: 1,
          adgroupTitleNum: 1,
          adgroupAdcreativeNum: 1,
          campaignAdgroupNum: 1,
          campaignSourceNum: 1,
          coverSourceNum: 1,
          adgroupType: []
        },
        actionTimeType: 'NOW',
        actionTime: [],
        scheduleTimeType: 'ALL',
        campaign: {
          campaign_name: '',
          type: '2',
          day_budget: '',
          day_budget_schedule: [
            '不限',
            '不限',
            '不限',
            '不限',
            '不限',
            '不限',
            '不限'
          ],
          // sub_type:'4',
          ad_type: '0'
        },
        adgroup: {
          unit_name: '',
          put_status: '2',
          bid_type: '10',
          cpa_bid: '',
          smart_bid: '0',
          smart_cover: 'false',
          asset_mining: 'false',
          ocpx_action_type: '',
          deep_conversion_type: '',
          deep_conversion_bid: '',
          roi_ratio: '',
          scene_id: '1',
          unit_type: '4',
          begin_time: '',
          end_time: '',
          schedule_time: '',
          day_budget: '',
          day_budget_schedule: [
            '不限',
            '不限',
            '不限',
            '不限',
            '不限',
            '不限',
            '不限'
          ],
          show_mode: '2',
          speed: '1',
          adv_card_option: '0',
          playable_id: '',
          play_button: '1'
        },
        adcreative: {
          package_name: '',
          action_bar: ''
        },
        targets: [], //[自增ID=>template_id]
        titles: [], //[title,title]
        canals: [], //自增ID=>[info信息]
        category: [], //[标签信息]
        sources: [],
        covers: [],

        selectAdvertiserId: '',
        selectAdvertisers: [],
        selectAdvertisersToNew: [],
        selectData: [],
        selectCanalData: [],
        selectTagData: [],
        selectSourceData: [],
        selectCoverData: [],

        time_type: 'NOW',
        task_name: '',
        templateName: ''
      },
      textForm: {
        textInfo: ''
      },
      rules: {
        tagRuls: {
          tagName: [
            {
              required: true,
              message: '请输入标签包名称',
              trigger: 'blur'
            }
          ],
          categoryId: [
            {
              type: 'array',
              required: true,
              message: '请输入创意分类',
              trigger: 'change'
            }
          ],
          tags: [
            {
              validator: function(rule, value, callback) {
                var stringResult = value
                var error = []
                stringResult.forEach(function(item, index) {
                  if (item.length > 10 || item.length <= 0) {
                    error.push(1)
                  }
                })
                if (error.length > 0) {
                  callback(new Error('每个标签不能为空或不能大于10个字'))
                  return
                }
                if (error.length + this.tagForm.tags.length > 10) {
                  callback(new Error('最多添加10个标签'))
                  return
                }
                callback()
              }.bind(this),
              trigger: 'blur'
            },
            {
              type: 'array',
              required: true,
              message: '请创建标签，标签不能为空',
              trigger: 'change'
            }
          ]
        },
        textRuls: {
          textInfo: [
            {
              validator: function(rule, value, callback) {
                var data = value.split('\n')
                if (data.length <= 0) {
                  callback(new Error('请填写文案信息'))
                  return
                }
                var error = []
                data.forEach(function(item) {
                  if (item.length <= 0) {
                    error.push(1)
                  }
                })
                if (error.length > 0) {
                  callback(new Error('每项文案信息不能为空'))
                  return
                }
                callback()
              }.bind(this),
              trigger: 'blur'
            }
          ]
        },
        addRules: {
          advertiser_id: [
            {
              type: 'array',
              required: true,
              message: '请至少选择一个账户',
              trigger: 'change'
            }
          ],
          campaign: {
            campaign_name: [
              {
                required: true,
                message: '请输入计划名称',
                trigger: 'blur'
              }
            ],
            day_budget: [
              {
                validator: function(rule, value, callback) {
                  if (!value) {
                    callback(new Error('请输入单日预算金额'))
                  }

                  var regText = new RegExp(/((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/)
                  if (!regText.test(value)) {
                    callback(new Error('请输入正确金额'))
                  }
                  if (value < 500 || value > 100000000) {
                    callback(new Error('预算不小于500元，不超过100000000元'))
                  }
                  callback()
                }.bind(this),
                trigger: 'change'
              }
            ],
            day_budget_schedule: [
              {
                validator: function(rule, value, callback) {
                  var regText = new RegExp(/((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/)

                  if (value.length != 7) {
                    callback(new Error('请输入分日预算金额'))
                  }

                  value.forEach(function(item) {
                    if (!regText.test(item) && item !== '不限') {
                      callback(new Error('请输入正确金额'))
                    }
                    if (item < 500 || item > 100000000) {
                      callback(new Error('预算不小于500元，不超过100000000元'))
                    }
                  })
                  callback()
                }.bind(this),
                trigger: 'blur'
              }
            ],
            type: [
              {
                required: true,
                message: '请选择推广目标',
                trigger: 'change'
              }
            ]
          },
          adgroup: {
            unit_name: [
              {
                required: true,
                message: '请输入计划名称',
                trigger: 'blur'
              }
            ],
            schedule_time: [
              {
                required: true,
                message: '请选择时段',
                trigger: 'blur'
              }
            ],
            end_time: [
              {
                required: true,
                message: '请选择时间',
                trigger: 'blur'
              }
            ],
            show_mode: [
              {
                required: true,
                message: '请选择投放场景',
                trigger: 'change'
              }
            ],
            day_budget: [
              {
                validator: function(rule, value, callback) {
                  if (!value) {
                    callback(new Error('请输入单日预算金额'))
                  }

                  var regText = new RegExp(/((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/)
                  if (!regText.test(value)) {
                    callback(new Error('请输入正确金额'))
                  }
                  if (value < 100 || value > 100000000) {
                    callback(new Error('预算不小于100元，不超过100000000元'))
                  }
                  callback()
                }.bind(this),
                trigger: 'change'
              }
            ],
            day_budget_schedule: [
              {
                validator: function(rule, value, callback) {
                  var regText = new RegExp(/((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/)

                  if (value.length != 7) {
                    callback(new Error('请输入分日预算金额'))
                  }

                  value.forEach(function(item) {
                    if (!regText.test(item) && item !== '不限') {
                      callback(new Error('请输入正确金额'))
                    }
                    if (item < 100 || item > 100000000) {
                      callback(new Error('预算不小于500元，不超过100000000元'))
                    }
                  })

                  callback()
                }.bind(this),
                trigger: 'blur'
              }
            ],
            cpa_bid: [
              {
                validator: function(rule, value, callback) {
                  if (!value) {
                    callback(new Error('请输入转化目标出价'))
                  }

                  var regText = new RegExp(/((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/)
                  if (value.indexOf(',') != -1) {
                    var arr = value.split(',')
                    if (arr.length < 2) {
                      callback(
                        new Error(
                          '阶梯出价金额格式错误,至少需要两个出价,例:1.5,1.9,2.0'
                        )
                      )
                    }
                    var error = []
                    var xjError = []
                    var bError = []
                    for (let i = 0; i < arr.length; i++) {
                      if (!regText.test(arr[i])) {
                        error.push(1)
                        break
                      }
                      if (
                        (this.addForm.adgroup.ocpx_action_type == 2 ||
                          this.addForm.adgroup.ocpx_action_type == 180) &&
                        (arr[i] - 0 < 1 || arr[i] - 0 > 3000)
                      ) {
                        xjError.push(1)
                        break
                      }
                      if (
                        this.addForm.adgroup.ocpx_action_type == 53 &&
                        (value - 0 < 5 || value - 0 > 3000)
                      ) {
                        bError.push(1)
                        break
                      }
                    }
                    if (error.length > 0) {
                      callback(new Error('请输入正确的阶梯出价金额'))
                    }
                    if (xjError.length > 0) {
                      callback(
                        new Error(
                          '【行为数】或【激活数】目标类型每项金额不得低于1元高于3000'
                        )
                      )
                    }
                    if (bError.length > 0) {
                      callback(
                        new Error('【【表单数】目标类型金额不得低于5元高于3000')
                      )
                    }
                  } else if (value.indexOf('~') != -1) {
                    var arr = value.split('~')
                    if (arr.length != 2) {
                      callback(
                        new Error('区间出价格式错误,有且只有一组,例:1.5~1.9')
                      )
                    }
                    if (arr[1] - 0 < arr[0] - 0) {
                      callback(new Error('区间出价中结束金额必须大于开始金额'))
                    }
                    if (
                      (this.addForm.adgroup.ocpx_action_type == 2 ||
                        this.addForm.adgroup.ocpx_action_type == 180) &&
                      (arr[0] - 0 < 1 || arr[0] - 0 > 3000)
                    ) {
                      callback(
                        new Error(
                          '【行为数】或【激活数】目标类型开始和结束金额不得低于1元高于3000'
                        )
                      )
                    }
                    if (
                      this.addForm.adgroup.ocpx_action_type == 53 &&
                      (arr[0] - 0 < 5 || arr[0] - 0 > 3000)
                    ) {
                      callback(
                        new Error('【表单数】目标类型金额不得低于5元高于3000')
                      )
                    }
                    var error = []
                    for (let i = 0; i < arr.length; i++) {
                      if (!regText.test(arr[i])) {
                        error.push(1)
                        break
                      }
                    }

                    if (error.length > 0) {
                      callback(new Error('请输入正确的区间出价'))
                    }
                  } else {
                    if (!regText.test(value)) {
                      callback(new Error('请输入正确出价'))
                    }
                  }
                  callback()
                }.bind(this),
                trigger: 'blur'
              }
            ],
            ocpx_action_type: [
              {
                required: function(rule, value, callback) {
                  if (!value && this.addForm.adgroup.bid_type == '10') {
                    return true
                  }
                  return false
                },
                message: '稳健投放模式下优化目标必选',
                trigger: 'change'
              }
            ],
            deep_conversion_bid: [
              {
                validator: function(rule, value, callback) {
                  var regText = new RegExp(/((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/)
                  if (value.indexOf(',') != -1) {
                    var arr = value.split(',')
                    if (arr.length < 2) {
                      callback(
                        new Error(
                          '阶梯出价金额格式错误,至少需要两个出价,例:1.5,1.9,2.0'
                        )
                      )
                    }
                    var error = []
                    var cbdError = []
                    for (let i = 0; i < arr.length; i++) {
                      if (!regText.test(arr[i])) {
                        error.push(1)
                        break
                      }

                      if (this.addForm.adgroup.cpa_bid.indexOf(',') != -1) {
                        var biderror = []
                        var arrbid = this.addForm.adgroup.cpa_bid.split(',')
                        for (let ii = 0; ii < arrbid.length; ii++) {
                          if (arr[i] - 0 <= arrbid[ii] - 0) {
                            biderror.push(1)
                            break
                          }
                        }
                        if (biderror.length > 0) {
                          cbdError.push(1)
                        }
                      } else if (
                        this.addForm.adgroup.cpa_bid.indexOf('~') != -1
                      ) {
                        var arrbid = this.addForm.adgroup.cpa_bid.split('~')
                        if (arr[i] - 0 <= arrbid[1] - 0) {
                          cbdError.push(1)
                        }
                      } else {
                        if (arr[i] - 0 <= this.addForm.adgroup.cpa_bid - 0) {
                          cbdError.push(1)
                        }
                      }
                    }
                    if (error.length > 0) {
                      callback(new Error('请输入正确的阶梯出价金额'))
                    }
                    if (cbdError.length > 0) {
                      callback(new Error('深度出价必须大于目标转化出价的金额'))
                    }
                  } else if (value.indexOf('~') != -1) {
                    var arr = value.split('~')
                    // 验证区间格式
                    if (arr.length != 2) {
                      callback(
                        new Error('区间出价格式错误,有且只有一组,例:1.5~1.9')
                      )
                    }
                    // 验证深度区间需要大于目标出价每项
                    if (this.addForm.adgroup.cpa_bid.indexOf(',') != -1) {
                      var error = []
                      var arrbid = this.addForm.adgroup.cpa_bid.split(',')
                      for (let i = 0; i < arrbid.length; i++) {
                        if (arr[0] - 0 <= arrbid[i] - 0) {
                          error.push(1)
                          break
                        }
                      }
                      if (error.length > 0) {
                        callback(
                          new Error(
                            '深度出价必须大于转化目标阶梯出价的每项金额'
                          )
                        )
                      }
                    } else if (
                      this.addForm.adgroup.cpa_bid.indexOf('~') != -1
                    ) {
                      var arrbid = this.addForm.adgroup.cpa_bid.split('~')
                      if (arr[0] - 0 <= arrbid[1] - 0) {
                        callback(
                          new Error(
                            '深度出价必须大于转化目标区间出价的结束金额'
                          )
                        )
                      }
                    } else {
                      if (arr[0] - 0 <= this.addForm.adgroup.cpa_bid - 0) {
                        callback(new Error('深度出价必须大于转化目标出价'))
                      }
                    }
                    // 验证结束金额大于开始金额
                    if (arr[1] - 0 <= arr[0] - 0) {
                      callback(new Error('区间出价中结束金额必须大于开始金额'))
                    }

                    var error = []
                    for (let i = 0; i < arr.length; i++) {
                      if (!regText.test(arr[i])) {
                        error.push(1)
                        break
                      }
                    }

                    if (error.length > 0) {
                      callback(new Error('请输入正确的区间出价'))
                    }
                  } else {
                    if (!regText.test(value)) {
                      callback(new Error('请输入正确出价'))
                    }

                    if (this.addForm.adgroup.cpa_bid.indexOf(',') != -1) {
                      var error = []
                      var arr = this.addForm.adgroup.cpa_bid.split(',')
                      for (let i = 0; i < arr.length; i++) {
                        if (value - 0 <= arr[i] - 0) {
                          error.push(1)
                          break
                        }
                      }
                      if (error.length > 0) {
                        callback(
                          new Error(
                            '深度出价必须大于转化目标阶梯出价的每项金额'
                          )
                        )
                      }
                    } else if (
                      this.addForm.adgroup.cpa_bid.indexOf('~') != -1
                    ) {
                      var arr = this.addForm.adgroup.cpa_bid.split('~')
                      if (value - 0 <= arr[1] - 0) {
                        callback(
                          new Error(
                            '深度出价必须大于转化目标区间出价的结束金额'
                          )
                        )
                      }
                    } else {
                      if (value - 0 <= this.addForm.adgroup.cpa_bid - 0) {
                        callback(new Error('深度出价必须大于转化目标出价'))
                      }
                    }
                  }

                  callback()
                }.bind(this),
                trigger: 'blur'
              }
            ],
            roi_ratio: [
              {
                required: true,
                message: '请填写ROI系数',
                trigger: 'change'
              }
            ],
            scene_id: [
              {
                required: true,
                message: '请选择投放位置',
                trigger: 'change'
              }
            ],
            unit_type: [
              {
                required: true,
                message: '请选择创意形式',
                trigger: 'change'
              }
            ]
          },
          adcreative: {
            action_bar: [
              {
                required: true,
                message: '请选择按钮文案',
                trigger: 'change'
              }
            ],
            package_name: [
              {
                required: true,
                message: '请填写创意名称',
                trigger: 'blur'
              }
            ]
          },
          rule: {
            campaign_create_type: [
              {
                required: true,
                message: '请选择计划创建方式',
                trigger: 'change'
              }
            ],
            adgroup_create_type: [
              {
                required: true,
                message: '请选择广告组创建方式',
                trigger: 'change'
              }
            ],
            adgroup_create_type: [
              {
                required: true,
                message: '请选择创建方式',
                trigger: 'change'
              }
            ],
            adgroupSourceNum: [
              {
                required: true,
                message: '请选择广告组素材数量',
                trigger: 'change'
              }
            ],
            adgroupTitleNum: [
              {
                required: true,
                message: '请选择广告组作品语数量',
                trigger: 'change'
              }
            ],
            adgroupAdcreativeNum: [
              {
                required: true,
                message: '请选择广告组创意数量',
                trigger: 'change'
              }
            ],
            campaignSourceNum: [
              {
                required: true,
                message: '请选择单计划素材数量',
                trigger: 'change'
              }
            ],
            coverSourceNum: [
              {
                required: true,
                message: '请选择单素材使用封面数量',
                trigger: 'change'
              }
            ]
          },
          task_name: [
            {
              required: true,
              message: '请填写任务名称',
              trigger: 'blur'
            }
          ],
          budget_type: [
            {
              required: true,
              message: '请选择预算类型',
              trigger: 'change'
            }
          ],
          time_type: [
            {
              required: true,
              message: '请选择创建时间',
              trigger: 'change'
            }
          ],
          titles: [
            {
              type: 'array',
              required: true,
              message: '请至少填写一个文案',
              trigger: 'change'
            }
          ],
          canals: [
            {
              type: 'array',
              required: true,
              message: '请至少选择一个渠道',
              trigger: 'change'
            },
            {
              validator: function(rule, value, callback) {
                var selectIds = value.map(x => x['id'])
                var error = []
                this.addForm.selectAdvertisersToNew.forEach(function(
                  item,
                  index
                ) {
                  if (selectIds.indexOf(item.value) == -1) {
                    error.push(1)
                  }
                })
                if (error.length > 0) {
                  callback(new Error('还有账户未选择渠道'))
                }
                callback()
              }.bind(this),
              trigger: 'change'
            }
          ],
          sources: [
            {
              type: 'array',
              required: true,
              message: '请至少选择一个素材',
              trigger: 'change'
            },
            {
              validator: function(rule, value, callback) {
                var selectIds = value.map(x => x['id'])
                var error = []
                this.addForm.selectAdvertisersToNew.forEach(function(
                  item,
                  index
                ) {
                  if (selectIds.indexOf(item.value) == -1) {
                    error.push(1)
                  }
                })
                if (error.length > 0) {
                  callback(new Error('还有账户未选择素材'))
                }
                callback()
              }.bind(this),
              trigger: 'change'
            }
          ],
          targets: [
            {
              type: 'array',
              required: true,
              message: '请至少选择一个定向',
              trigger: 'change'
            },
            {
              validator: function(rule, value, callback) {
                var selectIds = value.map(x => x['id'])
                var error = []
                this.addForm.selectAdvertisersToNew.forEach(function(
                  item,
                  index
                ) {
                  if (selectIds.indexOf(item.value) == -1) {
                    error.push(1)
                  }
                })
                if (error.length > 0) {
                  callback(new Error('还有账户未选择定向包'))
                }
                callback()
              }.bind(this),
              trigger: 'change'
            }
          ],
          templateName: [
            {
              required: true,
              message: '请填写模板名称',
              trigger: 'change'
            }
          ]
        }
      },
      // 下拉数据
      options: {
        dynamicTags: [
          '推广目的',
          '时间',
          '应用名',
          '素材名',
          '渠道别名',
          '定向包名'
        ],
        accounts: [],
        account_options: [],
        targets_options: [],
        action_bar_text_options: [],
        new_expose_tag_options: [],
        new_play_options: [],
        category_options: [],
        ocpx_action_type_options: [],
        deep_conversion_type_options: []
      },
      // 销售线索维度表头
      taskFields: [
        {
          value: 'other.page_url',
          fieldName: '落地页/商品',
          width: '200'
        },
        {
          value: 'live_track_url',
          fieldName: '监测链接',
          width: '200'
        }
      ],
      // 列表table数据
      tableData: {
        total: 0,
        page: 1,
        rows: 20,
        list: []
      },
      targetTableData: {
        total: 0,
        page: 1,
        rows: 10,
        data: []
      },
      canalTableData: {
        total: 0,
        page: 1,
        rows: 10,
        data: []
      },
      tagTableData: {
        total: 0,
        page: 1,
        rows: 10,
        data: []
      },
      sourceTableData: {
        total: 0,
        page: 1,
        rows: 30,
        data: []
      },
      moreAccount: {
        list: []
      },
      viewData: [],
      viewInfo: [],
      dialogVisibleLabel: false,
      drawerInfo: {
        taskId: '',
        accountId: '',
        corporationName: ''
      },
      tableDataDrawer: {
        total: 0,
        page: 1,
        rows: 20,
        list: []
      },
      checkCovers: []
    }
  },
  watch: {
    'addForm.selectSourceData': function(newValue, oldValue) {
      if (newValue.length == 0) {
        this.allDisabled = true
      } else if (newValue.length == this.sourceTableData.data.length) {
        this.allDisabled = false
      }
    },
    'addForm.adgroup_type': function(newValue, oldValue) {
      if (newValue == 'none') {
        this.addForm.adgroup.scene_id = '1'
      } else if (newValue == 'lianmeng') {
        this.addForm.adgroup.scene_id = '5'
      }
    },
    'searchForm.type': function(newValue, oldValue) {
      if (newValue == 'TASK') {
        this.publicFields = [
          {
            value: 'id',
            label: '任务ID',
            width: '80px'
          },
          {
            value: 'taskName',
            label: '任务名称',
            width: '100px'
          },
          {
            value: 'formType',
            label: '投放来源',
            width: '100px'
          },
          {
            value: 'mediaName',
            label: '媒体',
            width: '180px'
          },
          {
            value: 'accountId',
            label: '账户信息',
            width: '300px'
          },
          {
            value: 'adminName',
            label: '创建人',
            width: '100px'
          },
          {
            value: 'createdTime',
            label: '创建时间',
            width: '180px'
          },
          {
            value: 'speed',
            label: '进度',
            width: '100px'
          },
          {
            value: 'status',
            label: '状态',
            width: '120px'
          },
          {
            value: 'log',
            label: '日志',
            width: 'auto'
          }
        ]
      } else if (newValue == 'TEMPLATE') {
        this.publicFields = []
      } else if (newValue == 'DEPOSIT') {
        this.publicFields = []
      }
    },
    'tagForm.categoryId': function(newValue, oldValue) {
      this.tagForm.categoryName = []
      if (newValue.length > 0) {
        this.options.category_options.forEach(
          function(item) {
            if (item.value == newValue[0]) {
              this.tagForm.categoryName.push(item.label)
              if (item.children.length > 0) {
                item.children.forEach(
                  function(it) {
                    if (it.value == newValue[1]) {
                      this.tagForm.categoryName.push(it.label)
                      if (it.children.length > 0) {
                        it.children.forEach(
                          function(ii) {
                            if (ii.value == newValue[2]) {
                              this.tagForm.categoryName.push(ii.label)
                            }
                          }.bind(this)
                        )
                      }
                    }
                  }.bind(this)
                )
              }
            }
          }.bind(this)
        )
      }
    },
    'addForm.playable_id_value': function(newValue, oldValue) {
      if (newValue == '0') {
        this.addForm.adgroup.playable_id = ''
        this.addForm.adgroup.play_button = ''
      } else if (newValue == '1') {
        this.addForm.adgroup.playable_id = ''
        this.addForm.adgroup.play_button = '1'
      }
    },
    // 'addForm.adcreative.category':function(newValue, oldValue){
    //     var news = [];
    //     if(newValue.length > 0){
    //         newValue.forEach(function(item){
    //             news.push({'text':item.label});
    //         })

    //     }
    //     this.addForm.adcreative.new_expose_tag = news;

    // },
    'addForm.actionTime': function(newValue, oldValue) {
      this.addForm.adgroup.begin_time = newValue[0]
      this.addForm.adgroup.end_time = newValue[1]
    },
    'addForm.actionTimeType': function(newValue, oldValue) {
      var times = this.getTime()
      if (newValue == 'NOW') {
        this.addForm.actionTime = []
        this.addForm.adgroup.begin_time = times[0]
        this.addForm.adgroup.end_time = ''
      } else {
        this.addForm.actionTime = times
        this.addForm.adgroup.begin_time = times[0]
        this.addForm.adgroup.end_time = times[1]
      }
    },
    'addForm.advertiser_id': function(newValue, oldValue) {
      this.options.accounts.forEach(
        function(item, index) {
          var id = item.value
          if (oldValue.indexOf(id) === -1 && newValue.indexOf(id) > -1) {
            this.addForm.selectAdvertisers.push(item)
          } else if (oldValue.indexOf(id) > -1 && newValue.indexOf(id) === -1) {
            var ii = this.addForm.selectAdvertisers.indexOf(item)
            this.addForm.selectAdvertisers.splice(ii, 1)
          }
        }.bind(this)
      )
    }
  },
  computed: {
    returnNumber: function() {
      return function(vid) {
        var returnTxt = 0
        this.addForm.selectCoverData.forEach(function(item, index) {
          if (item.id == vid) {
            returnTxt = item.selectNum
          }
        })
        return returnTxt
      }
    }
  },
  methods: {
    changeMedia: function() {
      this.$emit('update:media', '')
      this.$emit('update:dialogMediaVisible', true)
    },
    tabclick: function() {},
    returnTxt: function(tags) {
      return tags ? tags.join(',') : '暂无标签'
    },

    locationView: function() {
      window.location.replace('/Web/tpl/#adCreate/ksall.html')
    },
    clearCover: function() {
      this.dialogCoverVisible = false
    },
    autoNum: function(n) {
      var res = []
      var chars = [0, 1, 2, 3, 4, 5, 6, 7]
      var num = 7
      for (var i = 0; i < n; i++) {
        var id = Math.ceil(Math.random() * num)
        res.push(chars[id])
        chars.splice(id, 1)
        num--
      }
      return res
    },
    autoSelect: function() {
      this.addForm.selectCoverData.forEach(
        function(item, index) {
          var nums = this.autoNum(this.coverNum)
          item.coverList.forEach(
            function(it, i) {
              if (nums.indexOf(i) != -1) {
                it.checkStatus = true
              } else {
                it.checkStatus = false
              }
            }.bind(this)
          )
        }.bind(this)
      )
    },
    addCover: function() {
      var checkCover = []
      this.addForm.covers = []
      this.addForm.selectCoverData.forEach(
        function(item, index) {
          var num = []
          item.coverList.forEach(
            function(it, i) {
              if (it.checkStatus == true) {
                num.push(it)
                checkCover.push(it.url)
                this.addForm.covers.push({
                  id: item.id,
                  info: it.url
                })
              }
              item.selectNum = num.length
            }.bind(this)
          )
        }.bind(this)
      )
      this.checkCovers = checkCover //存储已选的，供再次打开回显用
      this.dialogCoverVisible = false
    },
    openCover: function(info) {
      this.dialogCoverVisible = true
      this.loading = true
      if (info != '') {
        this.coverDisabled = true
        this.coverOption = '手动选择'
        var selectIds = this.addForm.selectCoverData.map(x => x['id'])
        if (selectIds.indexOf(info.videoId) == -1) {
          this.$api.post(
            'release/getCoverListByVideos',
            {
              list: [info]
            },
            res => {
              if (res.code == 0) {
                res.data.forEach(
                  function(item, index) {
                    var num = []
                    item.coverList.forEach(
                      function(it, i) {
                        if (this.checkCovers.indexOf(it.url) != -1) {
                          it.checkStatus = true
                          num.push(1)
                        }
                      }.bind(this)
                    )
                    item.selectNum = num.length
                  }.bind(this)
                )
                this.addForm.selectCoverData.push(res.data[0])
              } else {
                this.$notify({
                  title: '警 告',
                  message: res.message,
                  type: 'warning'
                })
              }
            }
          )
        }
        this.addForm.selectCoverData.forEach(function(item, index) {
          if (item.id != info.videoId) {
            item.isShow = false
          } else {
            item.isShow = true
          }
        })
      } else {
        this.coverDisabled = false
        var list = this.addForm.selectSourceData
        this.$api.post(
          'release/getCoverListByVideos',
          {
            list: list
          },
          res => {
            if (res.code == 0) {
              res.data.forEach(
                function(item, index) {
                  var num = []
                  item.coverList.forEach(
                    function(it, i) {
                      if (this.checkCovers.indexOf(it.url) != -1) {
                        it.checkStatus = true
                        num.push(1)
                      }
                    }.bind(this)
                  )
                  item.selectNum = num.length
                }.bind(this)
              )
              this.addForm.selectCoverData = res.data
            } else {
              this.$notify({
                title: '警 告',
                message: res.message,
                type: 'warning'
              })
            }
          }
        )
      }
      // this.loading = false
    },
    stopVideo: function(id) {
      var x = document.getElementById(id)
      x.pause()
    },
    showView: function(item) {
      this.dialogImageUrl = item
      this.showDialogVisible = true
    },
    handleCommand: function(command) {
      this.sourceForm.sourceFrom = command
      if (command == 'LOCAL') {
        this.lineDisabled = false
      } else {
        this.lineDisabled = true
      }
      this.getSourceInfo()
    },
    //  保存模板
    submitTemplate: function() {
      this.$refs[form].validate(
        function(valid) {
          if (valid) {
          }
        }.bind(this)
      )
    },
    handleSearchDrawer: function() {
      this.$api.get(
        'adPromotion/openLogDialog',
        {
          taskId: this.drawerInfo.taskId,
          //   accountId: this.drawerInfo.accountId,
          //   corporationName: this.drawerInfo.corporationName,
          page: this.tableDataDrawer.page
          //   rows: this.tableDataDrawer.rows
        },
        res => {
          this.loading = false
          if (res.code == 0) {
            var info = res.data
            this.tableDataDrawer.total = info.total
            this.tableDataDrawer.list = info.data
            this.$message({
              message: '查询列表信息成功！',
              type: 'success'
            })
          } else {
            this.$notify({
              title: '警 告',
              message: res.message,
              type: 'warning'
            })
          }
        }
      )
    },
    handleCurrentChangeDrawer: function(page) {
      this.tableDataDrawer.page = page
      this.handleSearchDrawer()
    },
    createLog: function(row) {
      this.dialogVisibleLabel = true
      this.loading = true
      this.drawerInfo.taskId = row.id
      this.drawerInfo.accountId = row.accountId
      this.drawerInfo.corporationName = row.corporationName

      this.handleSearchDrawer()
    },
    showMore: function(row) {
      this.$api.get(
        'APP/AdCreateTask/getMore',
        {
          taskId: row.id
        },
        res => {
          var data = res.data
          this.moreAccount.list = data.list
        }
      )
    },
    doSearch: function(page) {
      this.tableData.page = page
      this.getTaskList(page)
    },
    handleCurrentChange: function(page) {
      this.getTaskList(page)
    },
    getTaskList: function(page) {
      // 如果页面切换则停止计时器
      if (window.location.hash != '#adver' || media != 'KuaiShou') {
        clearInterval(this.timer)
        this.timer = null
      }

      this.$api.get(
        'adPromotion/adverTaskList',
        {
          page: page ? page : this.tableData.page,
          prop: 'id',
          order: 'desc',
          name: this.searchForm.taskName,
          time: this.searchForm.dateTime
        },
        res => {
          this.loading = false
          if (res.code == 0) {
            var info = res.data
            this.tableData.total = info.total
            this.tableData.list = info.data
          } else {
            this.$notify({
              title: '警 告',
              message: res.message,
              type: 'warning'
            })
          }
        }
      )
    },
    //  提交任务
    submitInfo: function(form, type) {
      this.loading = true
      this.$refs[form].validate(
        function(valid) {
          if (valid) {
            // 请求接口
            this.$api.post(
              this.getUrl.submit_url,
              {
                type: type,
                data: this.addForm
              },
              res => {
                if (res.code == '0') {
                  // 预览
                  if (type == 'VIEW') {
                    this.innerDrawer = true
                    this.viewData = res.data.data
                    this.viewInfo = res.data.info
                    this.loading = false
                  } else {
                    this.drawer = false
                    this.loading = false
                    this.$message.success('发布成功，定时任务页面查看发布状况')
                    this.searchForm.type = 'TASK'
                    this.getTaskList()
                  }
                } else {
                  this.$message.error(res.message)
                }
              }
            )
          } else {
            this.$message.error('提交项有错误，请修改！')
          }
          this.loading = false
        }.bind(this)
      )
    },
    remoteAccount: function(val) {
      this.getPublicSelectInfo(this.getUrl.account_url, 'accounts', {
        query: val
      })
    },
    addSources: function() {
      if (
        this.addForm.adgroup.unit_type == '7' &&
        this.addForm.adgroup.smart_cover == 'false' &&
        this.addForm.covers.length <= 0
      ) {
        this.$message.error('程序化创意,未开启智能抽帧，则必须选择封面')
        return
      }
      this.dialogSourceVisible = false
      this.addForm.sources = this.addForm.selectSourceData
    },
    //  清空所选素材
    cleaSource: function() {
      this.sourceTableData.data.forEach(
        function(item, index) {
          // var ii = this.sourceTableData.data.indexOf(item);
          this.sourceTableData.data[index]['isType'] = false
        }.bind(this)
      )
      // 删除封面相关信息
      this.addForm.selectCoverData = []
      //清楚选中的封面
      this.addForm.covers = []
      this.checkCovers = []

      var selectIds = this.addForm.selectSourceData.map(x => x['videoId'])
      this.addForm.selectSourceData = []
      this.delLocalSource(selectIds)
    },
    allSelect: function() {
      if (this.sourceTableData.data.length > 0) {
        this.allDisabled = false
        var selectIds = this.addForm.selectSourceData.map(x => x['videoId'])

        this.sourceTableData.data.forEach(
          function(info, index) {
            var ii = selectIds.indexOf(info.videoId)
            if (ii == -1) {
              this.addForm.selectSourceData.push({
                id: this.addForm.selectAdvertiserId,
                info: info,
                videoId: info.videoId
              })
              info.isType = true
            }
          }.bind(this)
        )
      }
    },
    allCanal: function() {
      if (this.sourceTableData.data.length > 0) {
        this.cleaSource()
        this.allDisabled = true
      }
    },
    //  点击添加一条素材
    addSourceItem: function(item) {
      var selectIds = this.addForm.selectSourceData.map(x => x['videoId'])

      var ii = selectIds.indexOf(item.videoId)
      this.sourceTableData.data.forEach(
        function(info, index) {
          if (info.videoId == item.videoId && ii == -1) {
            this.addForm.selectSourceData.push({
              id: this.addForm.selectAdvertiserId,
              info: info,
              videoId: info.videoId
            })
            info.isType = true
          } else if (info.videoId == item.videoId && ii != -1) {
            this.addForm.selectSourceData.splice(ii, 1)
            info.isType = false
          }
        }.bind(this)
      )
    },
    delLocalSource: function(ids) {
      this.$api.get(
        this.getUrl.source_del,
        {
          ids: ids
        },
        res => {
          if (res.code != '0') {
            this.$message.error(res.message)
          }
        }
      )
    },
    //  点击删除一条素材
    delSource: function(item) {
      this.delLocalSource([item.videoId])
      //  清除已选
      var index = this.addForm.selectSourceData.indexOf(item)
      this.addForm.selectSourceData.splice(index, 1)
      // //  修改选中效果
      // var ii = this.sourceTableData.data.indexOf(item);
      this.sourceTableData.data.forEach(
        function(info, i) {
          if (item.videoId == info.videoId) {
            this.sourceTableData.data[i]['isType'] = false
          }
        }.bind(this)
      )
      // 删除封面相关信息
      this.addForm.selectCoverData = this.addForm.selectCoverData.filter(
        function(it) {
          return it.id != item.videoId
        }
      )
      //删除选中的封面
      var covers = []
      this.addForm.covers = this.addForm.covers.filter(function(it) {
        if (it.id != item.videoId) {
          covers.push(it.info)
        } else {
          return it.id != item.videoId
        }
      })
      this.checkCovers = this.checkCovers.filter(function(it) {
        return covers.indexOf(it) != -1
      })
    },
    openSource: function() {
      if (this.addForm.advertiser_id.length > 0) {
        this.addForm.selectAdvertisersToNew = []
        JSON.parse(JSON.stringify(this.addForm.selectAdvertisers)).forEach(
          function(item, index) {
            var newItem = item
            if (index == 0) {
              newItem['class'] = 'hov'
            } else {
              newItem['class'] = ''
            }
            this.addForm.selectAdvertisersToNew.push(newItem)
          }.bind(this)
        )
        //   // 打开dialog
        this.dialogSourceVisible = true
        this.addForm.selectAdvertiserId = this.addForm.advertiser_id[0]
        // 默认或第一个账户定向
        this.getSourceInfo()
      } else {
        this.$message.error('请先选择批量投放的账户')
      }
    },
    //同步素材
    getLineInfo: function() {
      this.sourceDisabled = true
      this.loading = true
      this.$api.get(
        this.getUrl.sourceLine_url,
        {
          accountId: this.addForm.selectAdvertiserId
        },
        res => {
          if (res.code != '0') {
            this.$message.error(res.message)
          } else {
            this.getSourceInfo('', '')
          }
          this.sourceDisabled = false
          this.loading = false
        }
      )
    },
    getSourceInfo: function(id, page, rows) {
      // this.loading = true
      var query = {
        accountId: id ? id : this.addForm.selectAdvertiserId,
        from: this.sourceForm.sourceFrom,
        name: this.sourceForm.sourceNameInput,
        tag: this.sourceForm.sourceTag,
        status: this.sourceForm.sourceStatus,
        time: this.sourceForm.sourceTime,
        page: page ? page : 1,
        rows: rows ? rows : this.sourceTableData.rows
      }
      // 获取定向
      // 请求接口
      this.$api.get(this.getUrl.source_url, query, res => {
        if (res.code == '0') {
          var dataList = res.data
          var selectIds = this.addForm.selectSourceData.map(x => x['videoId'])

          dataList.data.forEach(
            function(item, index) {
              if (selectIds.indexOf(item.videoId) != -1) {
                item.isType = true
              } else {
                item.isType = false
              }
            }.bind(this)
          )
          this.sourceTableData = dataList
        } else {
          this.$message.error(res.message)
        }
        this.loading = false
      })
    },
    //  确定
    addTags: function() {
      this.addForm.category = this.addForm.selectTagData
      this.dialogTagVisible = false
    },
    //  切换
    exitEditId: function(tap) {
      if (tap.name == 'custom') {
        this.tagForm.id = ''
        this.tagName = ''
        this.categoryId = []
        this.categoryName = []
        this.tagsText = ''
        this.tags = []
      }
    },
    //  修改一条标签
    editTag: function(id) {
      this.getPublicSelectInfo(this.getUrl.category_url, 'category_options', {
        accountId: this.addForm.advertiser_id[0]
      })
      this.tagData.activeName = 'custom'
      //  获取一条数据
      this.$api.get(
        this.getUrl.getTag_url,
        {
          id: id
        },
        res => {
          if (res.code == '0') {
            this.tagForm = res.data
          } else {
            this.$message.error(res.message)
          }
        }
      )
    },
    //  删除一条标签
    delTag: function(id) {
      this.$api.get(
        this.getUrl.delTag_url,
        {
          id: id
        },
        res => {
          if (res.code == '0') {
            this.tagTableData.data.forEach(
              function(item, index) {
                if (item.id == id) {
                  this.tagTableData.data.splice(index, 1)
                }
              }.bind(this)
            )
          } else {
            this.$message.error(res.message)
          }
        }
      )
    },
    //  提交创建标签
    submitTagForm: function(form) {
      this.$refs[form].validate(
        function(valid) {
          if (valid) {
            var query = {
              id: this.tagForm.id ? this.tagForm.id : '',
              tagName: this.tagForm.tagName,
              categoryId: this.tagForm.categoryId,
              categoryName: this.tagForm.categoryName,
              tags: this.tagForm.tags
            }
            this.$api.post(this.getUrl.addTag_url, query, res => {
              if (res.code == '0') {
                this.tagData.activeName = 'tag'
                this.getTagInfo(1)
              } else {
                this.$message.error(res.message)
              }
            })
          }
        }.bind(this)
      )
    },
    addTagText: function() {
      var stringResult = this.tagForm.tagsText.split(' ')
      stringResult.forEach(
        function(item, index) {
          this.tagForm.tags.push(item)
        }.bind(this)
      )
      this.tagForm.tagsText = ''
    },
    tagClose: function(tag) {
      var index = this.tagForm.tags.indexOf(tag)
      this.tagForm.tags.splice(index, 1)
    },
    //打开标签框
    openTags: function() {
      if (this.addForm.advertiser_id.length > 0) {
        this.dialogTagVisible = true
        this.getTagInfo(1)
        this.getPublicSelectInfo(this.getUrl.category_url, 'category_options', {
          accountId: this.addForm.advertiser_id[0]
        })
      } else {
        this.$message.error('请先选择批量投放的账户')
      }
    },
    // 获取标签信息
    getTagInfo: function(page) {
      this.loading = true
      var query = {
        page: page ? page : 1,
        rows: this.tagTableData.rows,
        sidx: 'id',
        sord: 'desc'
      }
      // 获取标签
      // 请求接口
      this.$api.get(this.getUrl.tagList_url, query, res => {
        if (res.code == '0') {
          this.tagTableData = res.data
        } else {
          this.$message.error(res.message)
        }
        this.loading = false
      })
    },
    //重置类型
    resetType: function() {
      this.addForm.rule.campaign_create_type = ''
    },
    // 打开标题
    openText: function() {
      this.dialogTextVisible = true
    },
    // 添加标题
    addTitles: function() {
      this.$refs['textForm'].validate(valid => {
        if (valid) {
          this.dialogTextVisible = false
          this.addForm.titles = this.textForm.textInfo.split('\n')
        }
      })
    },
    //插入数据
    addToText: function(tag, form, fieldOne, field) {
      var dd = ''
      if (fieldOne && field) {
        dd = this[form][fieldOne][field]
      } else {
        dd = this[form][field]
      }

      var str = '{' + tag + '}'
      var index = dd.indexOf(str)

      if (index != -1) {
        dd = dd.replace(str, '')
      } else {
        var id = this.selectionStart

        if (id < dd.length) {
          //光标之前内容
          var strFront = dd.substring(0, id)
          var strBehind = dd.substring(id, dd.length)

          dd = strFront + str + strBehind
        } else {
          dd += str
        }
      }

      if (fieldOne && field) {
        this[form][fieldOne][field] = dd
      } else {
        this[form][field] = dd
      }
    },
    //获取焦点
    handleInputBlur: function(event) {
      var obj = event.srcElement ? event.srcElement : event.target
      if (obj.selectionStart && obj.selectionStart != 'undefind') {
        this.selectionStart = obj.selectionStart
      }
    },
    // 获取文案事件
    typeChange: function() {
      if (this.addForm.advertiser_id[0] && this.addForm.campaign.type) {
        var query = {
          accountId: this.addForm.advertiser_id[0],
          campaign_type: this.addForm.campaign.type,
          consult_type: 0
        }
        this.getPublicSelectInfo(
          this.getUrl.btnText_url,
          'action_bar_text_options',
          query
        )
      }
    },
    // 获取推荐理由下载
    exposeTagsChange: function() {
      if (this.addForm.advertiser_id[0]) {
        var query = {
          accountId: this.addForm.advertiser_id[0]
        }
        // var query = {accountId:10953};
        this.getPublicSelectInfo(
          this.getUrl.exposeTags_url,
          'new_expose_tag_options',
          query
        )
      }
    },
    // 获取试玩素材
    playableChange: function() {
      if (this.addForm.advertiser_id[0]) {
        var query = {
          accountId: this.addForm.advertiser_id[0]
        }
        // var query = {accountId:10953};
        this.getPublicSelectInfo(
          this.getUrl.play_url,
          'new_play_options',
          query
        )
      }
    },
    // 打开渠道包
    openCanal: function() {
      if (this.addForm.advertiser_id.length > 0) {
        this.addForm.selectAdvertisersToNew = []
        JSON.parse(JSON.stringify(this.addForm.selectAdvertisers)).forEach(
          function(item, index) {
            var newItem = item
            if (index == 0) {
              newItem['class'] = 'hov'
            } else {
              newItem['class'] = ''
            }

            this.addForm.selectAdvertisersToNew.push(newItem)
          }.bind(this)
        )

        // 打开dialog
        this.dialogCanalVisible = true

        this.addForm.selectAdvertiserId = this.addForm.advertiser_id[0]
        // 默认或第一个账户定向
        this.getCanalInfo(this.addForm.advertiser_id[0])
      } else {
        this.$message.error('请先选择批量投放的账户')
      }
    },
    // 打开定向
    openTarget: function() {
      if (this.addForm.advertiser_id.length > 0) {
        this.addForm.selectAdvertisersToNew = []
        JSON.parse(JSON.stringify(this.addForm.selectAdvertisers)).forEach(
          function(item, index) {
            var newItem = item
            if (index == 0) {
              newItem['class'] = 'hov'
            } else {
              newItem['class'] = ''
            }

            this.addForm.selectAdvertisersToNew.push(newItem)
          }.bind(this)
        )

        // 打开dialog
        this.dialogTargetVisible = true

        this.addForm.selectAdvertiserId = this.addForm.advertiser_id[0]
        // 默认或第一个账户定向
        this.getTargetInfo(this.addForm.advertiser_id[0])
      } else {
        this.$message.error('请先选择批量投放的账户')
      }
    },
    // 全选
    selectAll: function(vals, field, fieldTable) {
      if (vals.length > 0) {
        vals.forEach(
          function(item) {
            var index = JSON.stringify(this['addForm'][field]).indexOf(
              JSON.stringify(item)
            )
            if (index === -1) {
              this['addForm'][field].push(item)
            }
          }.bind(this)
        )
      } else {
        this[fieldTable].data.forEach(
          function(item) {
            var index = this['addForm'][field].findIndex(v => {
              return v.value == item.value
            })
            this['addForm'][field].splice(index, 1)
          }.bind(this)
        )
      }
    },
    // 选择
    handleSelectionChange: function(row, column, event, field, fieldRef) {
      if (
        JSON.stringify(this['addForm'][field]).indexOf(JSON.stringify(row)) ===
        -1
      ) {
        this.$refs[fieldRef].toggleRowSelection(row, true)
        this['addForm'][field].push(row)
      } else {
        var index = this['addForm'][field].indexOf(row)
        this.$refs[fieldRef].toggleRowSelection(row, false)
        this['addForm'][field].splice(index, 1)
      }
    },
    // 清空定向
    cleanTarget: function(data, fieldRef) {
      this['addForm'][data] = []
      this.$refs[fieldRef].clearSelection()
    },
    // 删除一条定向
    delTarget: function(index, data, fieldRef) {
      this.$refs[fieldRef].toggleRowSelection(
        this['addForm'][data][index],
        false
      )
      this['addForm'][data].splice(index, 1)
    },

    // 选择定向包
    addTargets: function() {
      this.addForm.targets = []
      if (this.addForm.selectData.length > 0) {
        this.addForm.selectData.forEach(
          function(item, id) {
            this.addForm.targets.push({
              id: item.advertiser_id,
              info: item.value,
              name: item.label,
              target: item.target
            })
          }.bind(this)
        )
      }
      // 关闭dialog
      this.dialogTargetVisible = false
    },
    //选择渠道包
    addCanal: function() {
      this.addForm.canals = []
      if (this.addForm.selectCanalData.length > 0) {
        this.addForm.selectCanalData.forEach(
          function(item, id) {
            this.addForm.canals.push({
              id: item.advertiser_id,
              info: item.canal
            })
          }.bind(this)
        )
      }
      // 关闭dialog
      this.dialogCanalVisible = false
    },
    // 打开批量创建抽屉
    openAllActionDrawer: function() {
      this.drawer = true
      this.getPublicSelectInfo(this.getUrl.account_url, 'accounts')
    },
    // 获取今日时间
    getTime: function() {
      var now = new Date()
      var year = now.getFullYear()
      var month = now.getMonth()
      var date = now.getDate()
      month = month + 1
      month = month.toString().padStart(2, '0')
      date = date.toString().padStart(2, '0')

      return [year + '-' + month + '-' + date, year + '-' + month + '-' + date]
    },
    handleCurrentChangeTarget: function(page) {
      this.getTargetInfo(this.addForm.selectAdvertiserId, page)
    },
    handleCurrentChangeCanal: function(page) {
      this.getCanalInfo(this.addForm.selectAdvertiserId, page)
    },
    handleSizeChange: function(val) {
      this.getSourceInfo(this.addForm.selectAdvertiserId, '', val)
    },
    handleCurrentChangeSource: function(page) {
      this.getSourceInfo(this.addForm.selectAdvertiserId, page)
    },
    handleCurrentChangeTag: function(page) {
      this.getTagInfo(page)
    },
    clickTarget: function(id, index, type) {
      this.addForm.selectAdvertiserId = id
      this.addForm.selectAdvertisersToNew.forEach(function(item, ii) {
        if (index == ii) {
          item['class'] = 'hov'
        } else {
          item['class'] = ''
        }
      })
      if (type == 'tar') {
        this.getTargetInfo(id)
      } else if (type == 'place') {
        this.getCanalInfo(id)
      } else if (type == 'source') {
        this.getSourceInfo(id)
      }
    },

    // 获取渠道消息
    getCanalInfo: function(id, page) {
      this.loading = true

      var query = {
        advertiser_id: id,
        type: this.addForm.campaign.type,
        page: page ? page : 1,
        rows: this.canalTableData.rows
      }
      // 获取定向
      // 请求接口
      this.$api.get(this.getUrl.canal_url, query, res => {
        if (res.code == '0') {
          this.canalTableData = res.data
          if (this.canalTableData.data.length > 0) {
            var ids = this.addForm.selectCanalData.map(x => x['value'])
            this.$nextTick(() => {
              this.canalTableData.data.forEach(
                function(item, index) {
                  if (ids.indexOf(item.value) != -1) {
                    this.$refs['canalTable'].toggleRowSelection(item, true)
                  }
                }.bind(this)
              )
            })
          } else {
            this.canalTableData.data = []
          }
        } else {
          this.$message.error(res.message)
        }
        this.loading = false
      })
    },
    // 获取定向消息
    getTargetInfo: function(id, page) {
      this.loading = true
      var query = {
        accountId: id,
        page: page ? page : 1,
        rows: this.targetTableData.rows
      }
      // 获取定向
      // 请求接口
      this.$api.get(this.getUrl.target_url, query, res => {
        if (res.code == '0') {
          this.targetTableData = res.data
          if (this.targetTableData.data.length > 0) {
            var ids = this.addForm.selectData.map(x => x['value'])

            this.$nextTick(() => {
              this.targetTableData.data.forEach(
                function(item, index) {
                  if (ids.indexOf(item.value) != -1) {
                    this.$refs['targetTable'].toggleRowSelection(item, true)
                  }
                }.bind(this)
              )
            })
          } else {
            this.targetTableData.data = []
          }
        } else {
          this.$message.error(res.message)
        }
        this.loading = false
      })
    },
    // 远程搜索账户
    remoteMethodAccount: function(query) {
      this.getPublicSelectInfo(this.getUrl.account_url, 'account_options', {
        query: query
      })
    },

    // 公共下拉请求适用于options下拉
    getPublicSelectInfo: function(url, optionField, query) {
      if (JSON.stringify(query) === '{}') {
        var query = {
          query: ''
        }
      }
      // 请求接口
      this.$api.get(url, query, res => {
        if (res.code == '0') {
          this.options[optionField] = res.data
        } else {
          this.$message.error(res.message)
        }
      })
    },
    accountChange: function(vals) {
      // 每次账户变化后，清除删除后的账户
      var i = this.addForm.selectAdvertisersToNew.length
      while (i--) {
        if (vals.indexOf(this.addForm.selectAdvertisersToNew[i].value) === -1) {
          this.addForm.selectAdvertisersToNew.splice(i, 1)
        }
      }
      // 删除定向item
      if (this.addForm.targets.length > 0) {
        var i = this.addForm.selectData.length
        while (i--) {
          if (vals.indexOf(this.addForm.selectData[i].advertiser_id) === -1) {
            this.addForm.selectData.splice(i, 1)
          }
        }
        var i = this.addForm.targets.length
        while (i--) {
          if (vals.indexOf(this.addForm.targets[i].id) === -1) {
            this.addForm.targets.splice(i, 1)
          }
        }
      }
      // 删除渠道
      if (this.addForm.canals.length > 0) {
        var i = this.addForm.selectCanalData.length
        while (i--) {
          if (
            vals.indexOf(this.addForm.selectCanalData[i].advertiser_id) === -1
          ) {
            this.addForm.selectCanalData.splice(i, 1)
          }
        }
        var i = this.addForm.canals.length
        while (i--) {
          if (vals.indexOf(this.addForm.canals[i].id) === -1) {
            this.addForm.canals.splice(i, 1)
          }
        }
      }

      // 删除素材
      if (this.addForm.sources.length > 0) {
        var i = this.addForm.sources.length
        while (i--) {
          if (vals.indexOf(this.addForm.sources[i].id) === -1) {
            var item = this.addForm.sources[i]
            this.delLocalSource([item.videoId])

            // //  修改选中效果
            // var ii = this.sourceTableData.data.indexOf(item);
            this.sourceTableData.data.forEach(
              function(info, i) {
                if (item.videoId == info.videoId) {
                  this.sourceTableData.data[i]['isType'] = false
                }
              }.bind(this)
            )
            // 删除封面相关信息
            this.addForm.selectCoverData = this.addForm.selectCoverData.filter(
              function(it) {
                return it.id != item.videoId
              }
            )

            //删除选中的封面
            var covers = []
            this.addForm.covers = this.addForm.covers.filter(function(it) {
              if (it.id != item.videoId) {
                covers.push(it.info)
              } else {
                return it.id != item.videoId
              }
            })
            this.checkCovers = this.checkCovers.filter(function(it) {
              return covers.indexOf(it) != -1
            })

            this.addForm.sources.splice(i, 1)
          }
        }
      }

      if (this.addForm.advertiser_id.length > 0 && this.addForm.campaign.type) {
        this.getPublicSelectInfo(
          this.getUrl.ocpx_url,
          'ocpx_action_type_options',
          {
            accountId: this.addForm.advertiser_id[0],
            campaignType: this.addForm.campaign.type
          }
        )
      } else {
        this.$message.error('至少选择一个账户')
      }
    },
    clearChange: function() {
      this.addForm.adgroup.ocpx_action_type = ''
    },
    //获取深度目标
    deepConverChange: function(val) {
      if (
        !this.addForm.advertiser_id[0] ||
        !this.addForm.campaign.type ||
        !this.addForm.adgroup.scene_id ||
        this.addForm.canals.length <= 0
      ) {
        this.$message.error('缺少参数')
      } else {
        this.getPublicSelectInfo(
          this.getUrl.deep_url,
          'deep_conversion_type_options',
          {
            accountId: this.addForm.advertiser_id[0],
            campaignType: this.addForm.campaign.type,
            scene_ids: this.addForm.adgroup.scene_id,
            ocpx_action_type: val,
            appId: this.addForm.canals[0]['info']['application']
          }
        )
      }
    }
  },
  // 初始化参数
  mounted: function() {
    this.searchForm.dateTime = this.getTime()
    this.addForm.begin_time = this.getTime()[0]
    this.getPublicSelectInfo(this.getUrl.account_url, 'account_options')
    if (this.searchForm.type == 'TASK') {
      this.getTaskList()
      this.timer = setInterval(this.getTaskList, 10000)
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>
<style scoped>
.box-eltab {
  width: 100%;
}

.top-filter {
  background-color: #fff;
  padding: 16px 16px 0;
}

.ks_content {
  background: #fff;
  width: calc(100% - 32px);
  margin: 0 auto;
  padding: 16px;
  box-sizing: border-box;
}

.ks_toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ks_toolbar .title {
  font-size: 16px;
  font-weight: bold;
  display: flex;
}

.ks_toolbar .title span {
  font-size: 14px;
  color: #999;
  font-weight: normal;
  margin-left: 10px;
}

.target-box {
  display: flex;
  justify-content: space-between;
  height: calc(100% - 54px);
}

.target-box-left {
  width: 270px;
  border: 1px solid #ebeef5;
  overflow: auto;
}

.k-page-content /deep/ .target-dialog {
  height: calc(100% - 80px);
}

.k-page-content /deep/ .target-dialog .el-dialog__body {
  height: calc(100% - 110px);
}

.target-box-left ul li {
  display: block;
  line-height: 44px;
  height: 44px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  padding: 0 10px;
  box-sizing: border-box;
  border-bottom: 1px solid #ebeef5;
  cursor: pointer;
}

.target-box-left ul li.hov,
.target-box-left ul li:hover {
  color: #007ad6;
  background: #f5f7fa;
}

.target-box-right {
  margin-left: 16px;
  width: calc(100% - 270px);
  display: flex;
  flex-wrap: wrap;
}

.target-box-right-top {
  border: 1px solid #ebeef5;
  background: #f5f7fa;
  padding: 12px;
  box-sizing: border-box;
  height: 54px;
  width: 100%;
}

.target-box-right-bot {
  display: flex;
  width: 100%;
  /* height:calc(100% - 70px);margin-top:16px; */
  height: 100%;
  justify-content: space-between;
}

.target-checked {
  width: 270px;
  border: 1px solid #ebeef5;
  height: 100%;
  margin-left: 16px;
}

.target-checked h3 {
  height: 30px;
  line-height: 30px;
  background: #f5f7fa;
  font-size: 14px;
  font-weight: normal;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  border-bottom: 1px solid #ebeef5;
}

.target-checked h3 span:nth-child(1) {
  color: #000;
}

.target-checked h3 span:nth-child(2) {
  color: #007ad6;
  cursor: pointer;
}

.target-checked-con {
  padding: 10px 0;
  box-sizing: border-box;
  height: calc(100% - 31px);
  overflow: auto;
}

.target-checked ul li {
  padding: 0 12px;
  line-height: 25px;
  font-size: 14px;
  position: relative;
}

.target-checked ul li i {
  display: block;
  position: absolute;
  right: 12px;
  top: 0;
  line-height: 25px;
  cursor: pointer;
}

.target-data {
  width: calc(100% - 270px);
  height: calc(100% - 40px);
}

.target-data .el-pagination {
  padding: 5px;
  border: 1px solid #ebeef5;
  border-top: none;
}

.box-card {
  margin-bottom: 30px;
}

.k-page-content /deep/ .target-dialog .el-tabs {
  height: 100%;
}

.k-page-content /deep/ .target-dialog .el-tabs .el-tabs__content {
  height: calc(100% - 55px);
}

.k-page-content /deep/ .target-dialog .el-tabs .el-tabs__content .el-tab-pane {
  height: 100%;
}

.k-page-content
  /deep/
  .target-dialog
  .el-tabs
  .el-tabs__content
  .el-tab-pane
  .target-box {
  height: 100%;
}

.k-page-content /deep/ .target-dialog .el-dialog__body {
  padding: 0 16px;
}

.sourceBox {
  display: flex;
  flex-flow: column;
  height: 100%;
}

.sourceBoxTop {
  height: 30px;
}

.sourceBoxCen {
  height: calc(100% - 40px);
  margin-top: 10px;
  display: flex;
  box-sizing: border-box;
  border-right: 1px solid #ebeef5;
  border-top: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}

.sourceBoxCenLeft {
  width: 200px;
  border-left: 1px solid #ebeef5;
  box-sizing: border-box;
}

.sourceBoxCenLeft .target-box-left {
  width: 100%;
  border: none;
}

.sourceBoxCenLeft .target-box-left ul li {
  height: 30px;
  line-height: 30px;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sourceBoxCenCon {
  width: calc(100% - 540px);
  box-sizing: border-box;
  border-left: 1px solid #ebeef5;
}

.sourceBoxCenRight {
  width: 340px;
  box-sizing: border-box;
  border-left: 1px solid #ebeef5;
}

.sourceHeader {
  padding: 0 6px;
  font-size: 12px;
  height: 34px;
  box-sizing: border-box;
  line-height: 34px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f5f7fa;
  border-bottom: 1px solid #ebeef5;
}

.sourceCenter {
  height: calc(100% - 50px);
  position: relative;
  margin-top: 16px;
  box-sizing: border-box;
}

.sourceOption {
  height: calc(100% - 40px);
  overflow: auto;
}

.sourceOptionPage {
  height: 40px;
  box-sizing: border-box;
  line-height: 40px;
  background: #f5f7fa;
  border-top: 1px solid #ebeef5;
  position: absolute;
  bottom: 0;
  width: 100%;
  left: 0;
}

.material-component {
  float: left;
}

.block-mid-lis {
  width: 120px;
  height: 160px;
  margin: 0 0 0 19px;
  position: relative;
  cursor: pointer;
}

.block-mid-lis .mid-lis-img {
  width: 120px;
  height: 120px;
  vertical-align: middle;
  overflow: hidden;
  background: #f9f9f9;
  border: 1px solid hsla(0, 0%, 80%, 0.5);
  position: relative;
}

.block-mid-lis .mid-lis-img .imgBox-Box {
  width: 120px;
  height: 120px;
  vertical-align: middle;
  display: table-cell;
  text-align: center;
}

.adesk__material-use-status {
  position: absolute;
  top: 0;
  right: 0;
  display: block;
  width: 33.33%;
  height: 24px;
  border-bottom-left-radius: 5px;
  font-size: 12px;
  color: #fff;
  text-align: center;
  line-height: 24px;
}

.adesk__material-use-status.status-1 {
  background-color: #f90;
}

.adesk__material-use-status.status-0 {
  background-color: #ed4014;
}

.adesk__material-use-status.status-2 {
  background-color: #657180;
}

.adesk__material-use-status.status-3 {
  background-color: #69f;
}

.block-mid-lis .mid-lis-img .imgBox-Box .imgBox-img {
  position: absolute;
  max-width: 100%;
  max-height: 100%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.adesk__material-show {
  position: absolute;
  right: 2px;
  bottom: 1px;
}

.mid-lis-title {
  display: -webkit-box;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.sourceSelect {
  height: calc(100% - 32px);
  margin-top: 16px;
  overflow: auto;
}

.material-info {
  height: 60px;
  line-height: 60px;
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
}

.material-info .material-info-base {
  display: flex;
  align-items: center;
}

.material-info .material-info-base .image {
  height: 50px;
  width: 40px;
  border: 1px solid #dee4f5;
  display: flex;
  justify-content: center;
  align-items: center;
}

.material-info .material-info-base .image img {
  max-width: 40px;
  max-height: 50px;
}

.material-info .material-info-base .material-name {
  margin: 10px;
  font-size: 12px;
  line-height: 25px;
  height: 80%;
  width: 230px;
}

.material-info .material-info-base .creative-templeate-tag {
  font-size: 11px;
  height: 18px;
  background-color: #3566d9;
  display: inline-block;
  line-height: 18px;
  border-radius: 3px;
  padding: 0 3px;
  color: #fff;
  margin-right: 3px;
  font-weight: 400;
  font-style: normal;
}

.material-info .material-delete {
  font-size: 18px;
  cursor: pointer;
}

.sourceTree {
  padding: 0 6px;
}

.block-mid-lis .mask-cover {
  position: absolute;
  top: 0;
  left: 0;
  width: 122px;
  height: 122px;
  line-height: 122px;
  z-index: 2;
  background-color: rgba(0, 0, 0, 0.7);
  text-align: center;
  padding: 15px 0;
  box-sizing: border-box;
  color: #fff;
}

.block-mid-lis .mask-cover i {
  font-size: 60px;
  font-weight: 700;
}

.adgroup_create_type .el-checkbox.is-bordered.el-checkbox--mini {
  width: 150px;
  height: 80px;
  position: relative;
}

.adgroup_create_type
  .el-checkbox.is-bordered.el-checkbox--mini
  .el-checkbox__label {
  position: absolute;
  left: 40px;
  top: 30px;
  width: 50px;
  text-align: center;
}

.kPlcreat .box-card {
  margin-bottom: 15px;
}

.coverTip {
  color: #999;
  line-height: 30px;
}

.kCover {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.coverTop {
  height: 85px;
  box-sizing: border-box;
  padding-top: 15px;
}

.coverBox {
  flex: 1;
  border: 1px solid #ebeef5;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.coverBoxTitle {
  font-size: 12px;
  height: 34px;
  line-height: 34px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f5f7fa;
  border-bottom: 1px solid #ebeef5;
}

.coverBoxTitle .left {
  width: 280px;
  box-sizing: border-box;
  border-right: 1px solid #ebeef5;
  padding: 0 8px;
}

.coverBoxTitle .right {
  align-items: center;
  flex: 1;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 8px;
}

.coverBoxCon {
  flex: 1;
  overflow-y: auto;
}

.coverList {
  border-bottom: 1px solid #ebeef5;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  height: 340px;
  align-items: center;
}

.coverList .left {
  width: 280px;
  box-sizing: border-box;
  padding: 10px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.coverList .right {
  flex: 1;
  padding: 0 10px;
  display: flex;
  flex-wrap: wrap;
}

.coverList .right div {
  width: 145px;
  height: 145px;
  background: #eaeef4;
  position: relative;
  margin: 5px 20px 5px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.coverList .right div img {
  max-width: 145px;
  max-height: 145px;
}

.coverList .right div .el-checkbox {
  position: absolute;
  left: 5px;
  top: 5px;
}

.previewDialog .el-drawer__body {
  overflow-y: scroll;
  padding: 10px 15px;
}

.previewTitle {
  padding-bottom: 15px;
}

.previewTitle span {
  position: relative;
  padding-left: 20px;
  display: inline-block;
  margin-right: 15px;
  font-weight: bold;
  font-size: 14px;
}

.previewTitle span:before {
  content: '';
  display: block;
  position: absolute;
  left: 0;
  top: 50%;
  margin-top: -2px;
  width: 8px;
  height: 4px;
  background-color: #507ae9;
}

.previewTitle span:nth-child(2):before {
  background-color: #f1b142;
}

.previewTitle span:nth-child(3):before {
  background-color: #8bc65e;
}

.sourceCover {
  display: flex;
  justify-content: center;
  position: relative;
}

.sourceCover img {
  width: 50px;
}

.sourceCover span {
  position: absolute;
  bottom: 5px;
  right: 10px;
  color: #4f79e8;
}
</style>
